import React, { useState, useEffect, useCallback, useMemo } from "react";
import { getFirestore, collection, query as queryFirestore, where, orderBy, getDocs, doc, updateDoc, setDoc, addDoc, onSnapshot } from 'firebase/firestore';
import { ref as storageRef, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage } from "../../firebase";
import {
    Autocomplete, Box, Button, CircularProgress, Container, Divider,
    FormControl, Paper, Snackbar, Table, TableBody, TableCell, Checkbox, Tooltip,
    TableContainer, TableHead, TableRow, TextField, Typography, Chip,
    Accordion, AccordionSummary, AccordionDetails, Stack, IconButton,
    Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText
} from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { utils, writeFile } from 'xlsx';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import JSZip from 'jszip';
import moment from "moment";
import MuiAlert from '@mui/material/Alert';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import SearchIcon from '@mui/icons-material/Search';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SelectAllIcon from '@mui/icons-material/SelectAll';
import ClearAllIcon from '@mui/icons-material/ClearAll';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import UnfoldLessIcon from '@mui/icons-material/UnfoldLess';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import FolderZipIcon from '@mui/icons-material/FolderZip';
import EditIcon from '@mui/icons-material/Edit';
import BlockIcon from '@mui/icons-material/Block';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import SendIcon from '@mui/icons-material/Send';
import SaveIcon from '@mui/icons-material/Save';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import LinkOffIcon from '@mui/icons-material/LinkOff';
import RefreshIcon from '@mui/icons-material/Refresh';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import SettingsIcon from '@mui/icons-material/Settings';

import { getCuadrillasOnce, updateCuadrillaFirestore } from "../../services/cuadrillasService";
import { getPricesOnce } from "../../services/priceService";
import ErrorPage from "../../components/ErrorPage/ErrorPage";
import { idCuadrillaBodega, idCuadrillaNucleo } from "../../utils/default";

const firestore = getFirestore();
const iconCheckbox = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIconCheckbox = <CheckBoxIcon fontSize="small" />;

const SnackAlert = React.forwardRef(function SnackAlert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const currentUser = JSON.parse(localStorage.getItem("currentUser"));

const fmt = (amount) => {
    if (amount === null || amount === undefined || amount === '') return '₲ 0';
    const n = typeof amount === 'string' ? parseFloat(amount) : amount;
    if (isNaN(n)) return '₲ 0';
    return new Intl.NumberFormat('es-PY', {
        style: 'currency', currency: 'PYG',
        minimumFractionDigits: 0, maximumFractionDigits: 0
    }).format(n);
};

const fmtNum = (amount) => {
    if (amount === null || amount === undefined || amount === '') return 0;
    const n = typeof amount === 'string' ? parseFloat(amount) : amount;
    return isNaN(n) ? 0 : n;
};

const SectionTitle = ({ children, color = '#1976d2' }) => (
    <Typography variant="h6" sx={{ mb: 1, color, fontWeight: 600, borderLeft: `4px solid ${color}`, pl: 1.5 }}>
        {children}
    </Typography>
);

const SummaryRow = ({ label, value, color, bold, size = 'body1' }) => (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 0.5, borderBottom: '1px solid #f0f0f0' }}>
        <Typography variant={size} color={color} fontWeight={bold ? 700 : 400}>{label}</Typography>
        <Typography variant={size} color={color} fontWeight={bold ? 700 : 400}>{value}</Typography>
    </Box>
);

const matchCuadrilla = (cuadrillaStr, selectedNum) => {
    if (!cuadrillaStr || !selectedNum) return false;
    return cuadrillaStr.split(' ')[0] === selectedNum.split(' ')[0];
};

const QUICK_MOTIVOS = [
    'No descargó materiales (Field Manager)',
    'Orden duplicada',
    'Rechazada / Cancelada por cliente',
    'Garantía / Reclamo de trabajo'
];

const ReporteComisiones = () => {
    const [alertValidationDate, setAlertValidationDate] = useState('');
    const [snackbarInfo, setSnackbarInfo] = useState({ open: false, text: '', type: 'neutral' });
    const [prices, setPrices] = useState({});
    const [cuadrillas, setCuadrillas] = useState([]);
    const [selectedCuadrillas, setSelectedCuadrillas] = useState([]);
    const [state, setState] = useState({ dateTo: null, dateFrom: null });
    const [loading, setLoading] = useState(false);
    const [downloadingZip, setDownloadingZip] = useState(false);
    const [rawReportData, setRawReportData] = useState(null);
    // checkOverrides: { [orderId]: boolean } - true = incluir en totales
    const [checkOverrides, setCheckOverrides] = useState({});
    // motivosOverrides: { [orderId]: string } - motivo de anulación
    const [motivosOverrides, setMotivosOverrides] = useState({});
    // Acordeones abiertos/cerrados: { [cuadrillaId]: boolean }
    const [expandedAccordions, setExpandedAccordions] = useState({});

    // Modal de motivo de anulación
    const [dialogAnulacion, setDialogAnulacion] = useState({
        open: false,
        orden: null,
        motivo: ''
    });

    // Estados para envío de liquidación por WhatsApp (híbrido: Bot Automático Render + Link PDF en Firebase Storage)
    const [openWhatsappModal, setOpenWhatsappModal] = useState(false);
    const [whatsappPhones, setWhatsappPhones] = useState({});
    const [whatsappSentMap, setWhatsappSentMap] = useState({});
    const [whatsappStatusMap, setWhatsappStatusMap] = useState({}); // { [cuadrillaId]: 'uploading' | 'queued' | 'sending' | 'sent' | 'error' }
    const [whatsappErrorMap, setWhatsappErrorMap] = useState({});   // { [cuadrillaId]: string }
    const [whatsappPdfUrls, setWhatsappPdfUrls] = useState({});     // { [cuadrillaId]: string (downloadURL) }
    const [autoDownloadPdfOnSend, setAutoDownloadPdfOnSend] = useState(false);
    const [savingPhoneId, setSavingPhoneId] = useState(null);
    const [bulkQueueIndex, setBulkQueueIndex] = useState(null);

    // Estado del servidor Bot de WhatsApp en Render (Opción 2)
    const [whatsappBotState, setWhatsappBotState] = useState({
        status: 'disconnected',
        qrDataUrl: null,
        connectedPhone: null,
        connectedName: null,
        lastHeartbeat: 0,
        serverUrl: 'https://personal-7o2a.onrender.com'
    });
    const [botServerUrlInput, setBotServerUrlInput] = useState('https://personal-7o2a.onrender.com');
    const [showBotConfig, setShowBotConfig] = useState(false);
    const [wakingUpBot, setWakingUpBot] = useState(false);

    // Función para despertar el servidor de Render en segundo plano
    const wakeUpWhatsappBotServer = useCallback((customUrl) => {
        const targetUrl = String(customUrl || whatsappBotState.serverUrl || botServerUrlInput || '').trim();
        if (!targetUrl || !targetUrl.startsWith('http')) return;
        setWakingUpBot(true);
        fetch(targetUrl, { mode: 'no-cors', cache: 'no-store' })
            .catch(() => {})
            .finally(() => {
                setTimeout(() => setWakingUpBot(false), 3000);
            });
    }, [whatsappBotState.serverUrl, botServerUrlInput]);

    const isBotActive = Boolean(
        whatsappBotState.status === 'connected' &&
        whatsappBotState.lastHeartbeat &&
        (Date.now() - whatsappBotState.lastHeartbeat < 90000)
    );

    useEffect(() => {
        getPricesOnce((data) => {
            const map = {};
            data.forEach(p => { map[p.id] = p; });
            setPrices(map);
        });
        getCuadrillasOnce((data) => {
            setCuadrillas(data.filter(c => c.id !== idCuadrillaBodega && c.id !== idCuadrillaNucleo));
        });

        // Escuchar estado en tiempo real del Bot de WhatsApp y despertarlo automáticamente al entrar a la pantalla
        let didInitialWakeup = false;
        const botRef = doc(firestore, 'configuracion', 'whatsapp_bot');
        const unsubBot = onSnapshot(botRef, (snap) => {
            if (snap.exists()) {
                const data = snap.data();
                setWhatsappBotState({
                    status: data.status || 'disconnected',
                    qrDataUrl: data.qrDataUrl || null,
                    connectedPhone: data.connectedPhone || null,
                    connectedName: data.connectedName || null,
                    lastHeartbeat: data.lastHeartbeat || 0,
                    serverUrl: data.serverUrl || ''
                });
                if (data.serverUrl) {
                    setBotServerUrlInput(prev => prev || data.serverUrl);
                    const isCurrentlyAwake = data.lastHeartbeat && (Date.now() - data.lastHeartbeat < 60000);
                    if (!didInitialWakeup && !isCurrentlyAwake) {
                        didInitialWakeup = true;
                        fetch(data.serverUrl, { mode: 'no-cors', cache: 'no-store' }).catch(() => {});
                    }
                }
            }
        });
        return () => unsubBot();
    }, []);

    const isAdmin = !!(currentUser && currentUser.rol === 'admin');

    const handleCloseSanckbar = (_, reason) => {
        if (reason === 'clickaway') return;
        setSnackbarInfo({ text: '', type: 'info', open: false });
    };

    const onChangeDateTo = (value) => {
        if (moment(new Date(value)).isBefore(moment(new Date()))) {
            setState(p => ({ ...p, dateTo: value }));
            setAlertValidationDate('');
        } else {
            setAlertValidationDate('La fecha debe ser menor o igual a la actual');
        }
    };

    const onChangeDateFrom = (value) => {
        if (moment(new Date(value)).isBefore(moment(new Date()))) {
            setState(p => ({ ...p, dateFrom: value }));
            setAlertValidationDate('');
        } else {
            setAlertValidationDate('La fecha debe ser menor o igual a la actual');
        }
    };

    const priceValueServices = useCallback((value, id, tipoDia) => {
        const newFilter = value?.filter(v => v.id === id);
        if (!newFilter?.length || !prices?.[id]) return 0;
        const isBoolean = typeof newFilter[0]?.value === 'boolean';
        const priceHogar = tipoDia === 'Semana'
            ? parseInt(prices[id]?.hogar, 10) || 0
            : parseInt(prices[id]?.feriado_domingo_hogar, 10) || 0;
        return isBoolean ? priceHogar : priceHogar * (parseInt(newFilter[0]?.value, 10) || 0);
    }, [prices]);

    const calculateOrderTotal = useCallback((order) => {
        if (!order?.services || !Array.isArray(order.services)) return 0;
        return order.services.reduce((sum, s) => sum + priceValueServices(order.services, s.id, order?.tipoDia), 0);
    }, [priceValueServices]);

    const calculateOrderPayout = useCallback((order, pct) => {
        if (!order?.services || !Array.isArray(order.services)) return 0;
        return order.services.reduce((sum, s) => {
            const newFilter = order.services.filter(v => v.id === s.id);
            if (!newFilter?.length || !prices?.[s.id]) return sum;

            const count = typeof newFilter[0]?.value === 'boolean'
                ? 1
                : (parseInt(newFilter[0]?.value, 10) || 0);

            const priceObj = prices[s.id];
            const isFixed = priceObj?.montoFijo === true || priceObj?.montoFijo === "true";

            let unitPayout = 0;
            if (isFixed) {
                const isSemana = order?.tipoDia === 'Semana';
                const customFixedSemana = parseInt(priceObj?.montoFijoValor, 10);
                const customFixedFeriado = parseInt(priceObj?.montoFijoFeriadoValor, 10);

                if (isSemana) {
                    unitPayout = !isNaN(customFixedSemana) ? customFixedSemana : (parseInt(priceObj?.hogar, 10) || 0);
                } else {
                    if (!isNaN(customFixedFeriado)) {
                        unitPayout = customFixedFeriado;
                    } else if (!isNaN(customFixedSemana)) {
                        unitPayout = customFixedSemana;
                    } else {
                        unitPayout = parseInt(priceObj?.feriado_domingo_hogar, 10) || parseInt(priceObj?.hogar, 10) || 0;
                    }
                }
            } else {
                const priceHogar = order?.tipoDia === 'Semana'
                    ? parseInt(priceObj?.hogar, 10) || 0
                    : parseInt(priceObj?.feriado_domingo_hogar, 10) || 0;
                unitPayout = priceHogar * pct;
            }

            return sum + (unitPayout * count);
        }, 0);
    }, [prices]);

    const handleGenerar = async () => {
        if (!selectedCuadrillas || selectedCuadrillas.length === 0 || !state.dateFrom || !state.dateTo) {
            setSnackbarInfo({ open: true, text: 'Debe seleccionar fecha desde, fecha hasta y al menos una cuadrilla', type: 'error' });
            return;
        }
        // Despertar preventivamente el servidor de WhatsApp en Render mientras se genera el reporte
        wakeUpWhatsappBotServer();

        setLoading(true);
        setRawReportData(null);
        try {
            const dateFrom = moment(state.dateFrom).format("YYYYMMDD");
            const dateTo = moment(state.dateTo).format("YYYYMMDD");

            // Consultas en paralelo para el rango de fechas
            const [
                ordenesSnap,
                adelantosSnap,
                combustibleSnap,
                garantiasSnap,
                descuentosSnap,
                herramientasSnap
            ] = await Promise.all([
                getDocs(queryFirestore(collection(firestore, 'ordenes'), orderBy('date', 'asc'), where('date', '>=', dateFrom), where('date', '<=', dateTo))),
                getDocs(queryFirestore(collection(firestore, 'adelantos'), orderBy('fecha', 'asc'), where('fecha', '>=', dateFrom), where('fecha', '<=', dateTo))),
                getDocs(queryFirestore(collection(firestore, 'combustible'), orderBy('fecha', 'asc'), where('fecha', '>=', dateFrom), where('fecha', '<=', dateTo))),
                getDocs(queryFirestore(collection(firestore, 'garantias'), orderBy('date', 'asc'), where('date', '>=', dateFrom), where('date', '<=', dateTo))),
                getDocs(queryFirestore(collection(firestore, 'descuentos'), orderBy('fecha', 'asc'), where('fecha', '>=', dateFrom), where('fecha', '<=', dateTo))),
                getDocs(queryFirestore(collection(firestore, 'movimientos_herramientas'), orderBy('fecha', 'asc'), where('fecha', '>=', dateFrom), where('fecha', '<=', dateTo)))
            ]);

            const allOrdenes = ordenesSnap.docs.map(d => ({ ...d.data(), id: d.id }));
            const allAdelantos = adelantosSnap.docs.map(d => ({ ...d.data(), id: d.id }));
            const allCombustible = combustibleSnap.docs.map(d => ({ ...d.data(), id: d.id }));
            const allGarantias = garantiasSnap.docs.map(d => ({ ...d.data(), id: d.id }));
            const allDescuentos = descuentosSnap.docs.map(d => ({ ...d.data(), id: d.id }));
            const allHerramientas = herramientasSnap.docs.map(d => ({ ...d.data(), id: d.id }));

            // Inicializar overrides: checkField true = no descargó = excluir (false)
            const initialOverrides = {};
            const initialMotivos = {};
            allOrdenes.forEach(o => {
                initialOverrides[o.id] = !o.checkField;
                initialMotivos[o.id] = o.motivoAnulacion || (o.checkField ? 'No descargó materiales' : '');
            });
            setCheckOverrides(initialOverrides);
            setMotivosOverrides(initialMotivos);

            // Guardar datos crudos
            setRawReportData({
                ordenes: allOrdenes,
                adelantos: allAdelantos,
                combustible: allCombustible,
                garantias: allGarantias,
                descuentos: allDescuentos,
                herramientasStock: allHerramientas
            });

            // Si hay 1 sola cuadrilla la abrimos por defecto
            const initialExp = {};
            selectedCuadrillas.forEach(c => {
                initialExp[c.id] = selectedCuadrillas.length === 1;
            });
            setExpandedAccordions(initialExp);

        } catch (error) {
            setSnackbarInfo({ open: true, text: `Error al generar el reporte: ${error.message}`, type: 'error' });
        } finally {
            setLoading(false);
        }
    };

    // Al hacer click en el checkbox de una orden:
    // Si está activa (true) -> Abrir modal para solicitar motivo de anulación
    // Si está anulada (false) -> Reactivarla directamente
    const handleClickCheckbox = (orden) => {
        const isCurrentlyActive = !!checkOverrides[orden.id];
        if (isCurrentlyActive) {
            // Abrir diálogo de anulación
            setDialogAnulacion({
                open: true,
                orden: orden,
                motivo: motivosOverrides[orden.id] || 'No descargó materiales (Field Manager)'
            });
        } else {
            // Reactivar orden directamente
            reactivarOrden(orden);
        }
    };

    const reactivarOrden = async (orden) => {
        const orderId = orden.id;
        setCheckOverrides(prev => ({ ...prev, [orderId]: true }));
        try {
            await updateDoc(doc(firestore, 'ordenes', String(orderId)), {
                checkField: false
            });
            setSnackbarInfo({ open: true, text: `Orden reactivada en la producción`, type: 'success' });
        } catch (e) {
            console.error('Error al reactivar orden:', e);
            setCheckOverrides(prev => ({ ...prev, [orderId]: false }));
            setSnackbarInfo({ open: true, text: `Error al reactivar orden: ${e.message}`, type: 'error' });
        }
    };

    const handleConfirmAnulacion = async () => {
        const { orden, motivo } = dialogAnulacion;
        if (!orden) return;

        const orderId = orden.id;
        const finalMotivo = motivo.trim() || 'No especificado';

        setCheckOverrides(prev => ({ ...prev, [orderId]: false }));
        setMotivosOverrides(prev => ({ ...prev, [orderId]: finalMotivo }));
        setDialogAnulacion({ open: false, orden: null, motivo: '' });

        try {
            await updateDoc(doc(firestore, 'ordenes', String(orderId)), {
                checkField: true,
                motivoAnulacion: finalMotivo
            });
            setSnackbarInfo({ open: true, text: `Orden anulada: ${finalMotivo}`, type: 'info' });
        } catch (e) {
            console.error('Error al anular orden:', e);
            setCheckOverrides(prev => ({ ...prev, [orderId]: true }));
            setSnackbarInfo({ open: true, text: `Error al guardar anulación: ${e.message}`, type: 'error' });
        }
    };

    const handleEditMotivo = (orden) => {
        setDialogAnulacion({
            open: true,
            orden: orden,
            motivo: motivosOverrides[orden.id] || orden.motivoAnulacion || ''
        });
    };

    // Procesamiento y cálculo de totales por cada cuadrilla y consolidado global
    const processedReports = useMemo(() => {
        if (!rawReportData || !selectedCuadrillas?.length) return null;

        const reportsByCuadrilla = selectedCuadrillas.map(cuadrilla => {
            const pct = (cuadrilla.porcentajeParticipacion || 0) / 100;

            const ordenes = rawReportData.ordenes.filter(o => o.idCuadrilla === cuadrilla.id);
            const adelantos = rawReportData.adelantos.filter(a => a.idCuadrilla === cuadrilla.id);
            const combustible = rawReportData.combustible.filter(c => c.idCuadrilla === cuadrilla.id);
            const garantias = rawReportData.garantias.filter(g => {
                const data = g[0] || g["0"] || g;
                const targetCuadrilla = data?.otRelacionada?.cuadrilla || data?.cuadrilla;
                return matchCuadrilla(targetCuadrilla, cuadrilla.numero);
            });
            const descuentos = rawReportData.descuentos.filter(d => d.idCuadrilla === cuadrilla.id);
            const herramientasStock = rawReportData.herramientasStock.filter(m => m.idCuadrilla === cuadrilla.id);

            // Cálculos
            const subtotalesOrdenes = ordenes.map(o => checkOverrides[o.id] ? calculateOrderPayout(o, pct) : 0);
            const totalSinIva = subtotalesOrdenes.reduce((s, v) => s + v, 0);
            const totalConIva = totalSinIva * 1.10;
            const totalAdelantos = adelantos.reduce((s, a) => s + fmtNum(a.monto), 0);
            const totalCombustible = combustible.reduce((s, c) => s + fmtNum(c.total), 0);

            const totalGarantias = garantias.reduce((sum, g) => {
                const data = g[0] || g["0"] || g;
                return sum + calculateOrderPayout(data, pct);
            }, 0);

            const listDescuentosOnly = descuentos.filter(d => !String(d.tipo || '').toUpperCase().includes('BONIFICACION'));
            const listBonificacionesOnly = descuentos.filter(d => String(d.tipo || '').toUpperCase().includes('BONIFICACION'));

            const totalDescuentos = listDescuentosOnly.reduce((s, d) => s + fmtNum(d.monto), 0);
            const totalBonificaciones = listBonificacionesOnly.reduce((s, d) => s + fmtNum(d.monto), 0);
            const totalHerramientas = herramientasStock.reduce((sum, h) => {
                const factor = h.tipo === 'salida' ? 1 : -1;
                return sum + (factor * h.cantidad * (h.herramientaPrecio || h.precio || 0));
            }, 0);

            const neto = totalConIva + totalBonificaciones - totalAdelantos - totalCombustible - totalDescuentos - totalGarantias - totalHerramientas;
            const totalFacturar = neto + totalAdelantos;

            return {
                cuadrilla,
                pct,
                data: {
                    ordenes,
                    adelantos,
                    combustible,
                    garantias,
                    descuentos,
                    herramientasStock
                },
                totales: {
                    subtotalesOrdenes,
                    totalSinIva,
                    totalConIva,
                    totalBonificaciones,
                    totalAdelantos,
                    totalCombustible,
                    totalGarantias,
                    totalDescuentos,
                    totalHerramientas,
                    neto,
                    totalFacturar
                }
            };
        });

        // Totales globales consolidados
        const globalTotales = reportsByCuadrilla.reduce((acc, rep) => {
            acc.totalSinIva += rep.totales.totalSinIva;
            acc.totalConIva += rep.totales.totalConIva;
            acc.totalBonificaciones += rep.totales.totalBonificaciones;
            acc.totalAdelantos += rep.totales.totalAdelantos;
            acc.totalCombustible += rep.totales.totalCombustible;
            acc.totalGarantias += rep.totales.totalGarantias;
            acc.totalDescuentos += rep.totales.totalDescuentos;
            acc.totalHerramientas += rep.totales.totalHerramientas;
            acc.neto += rep.totales.neto;
            acc.totalFacturar += rep.totales.totalFacturar;
            acc.totalOrdenes += rep.data.ordenes.length;
            acc.totalOrdenesLiquidadas += rep.data.ordenes.filter(o => !!checkOverrides[o.id]).length;
            return acc;
        }, {
            totalSinIva: 0,
            totalConIva: 0,
            totalBonificaciones: 0,
            totalAdelantos: 0,
            totalCombustible: 0,
            totalGarantias: 0,
            totalDescuentos: 0,
            totalHerramientas: 0,
            neto: 0,
            totalFacturar: 0,
            totalOrdenes: 0,
            totalOrdenesLiquidadas: 0
        });

        return { reportsByCuadrilla, globalTotales };
    }, [rawReportData, selectedCuadrillas, checkOverrides, calculateOrderPayout]);

    // Control de acordeones
    const toggleAccordion = (cuadrillaId) => {
        setExpandedAccordions(prev => ({
            ...prev,
            [cuadrillaId]: !prev[cuadrillaId]
        }));
    };

    const handleExpandAll = () => {
        const nextState = {};
        selectedCuadrillas.forEach(c => { nextState[c.id] = true; });
        setExpandedAccordions(nextState);
    };

    const handleCollapseAll = () => {
        const nextState = {};
        selectedCuadrillas.forEach(c => { nextState[c.id] = false; });
        setExpandedAccordions(nextState);
    };

    // Selección masiva de cuadrillas
    const handleSelectAllCuadrillas = () => {
        setSelectedCuadrillas(cuadrillas);
        setRawReportData(null);
    };

    const handleClearCuadrillas = () => {
        setSelectedCuadrillas([]);
        setRawReportData(null);
    };

    // Helper: exportar Excel de una sola cuadrilla
    const exportSingleCuadrillaExcel = (cuadrillaReport, periodo) => {
        const { cuadrilla, data, totales, pct } = cuadrillaReport;
        const wb = utils.book_new();

        // Hoja Órdenes (con activas y anuladas con motivo y valor 0)
        const wsOrdenes = utils.json_to_sheet((data.ordenes || []).map((o, i) => {
            const isActive = !!checkOverrides[o.id];
            const payout = isActive ? calculateOrderPayout(o, pct) : 0;
            const motivo = !isActive ? (motivosOverrides[o.id] || o.motivoAnulacion || 'No descargó materiales') : '';

            return {
                'Item': i + 1,
                'WO / Cita': o.workOrder || o.nroCita || '',
                'OT': o.nroOt || '',
                'Contrato': o.contrato || '',
                'Cliente': o.cliente || '',
                'Fecha': moment(o.date, "YYYYMMDD").format("DD/MM/YYYY"),
                'Estado': isActive ? 'PRODUCIDA' : 'ANULADA',
                'Motivo de Anulación': motivo,
                'Subtotal Pago (Gs.)': payout
            };
        }));
        utils.book_append_sheet(wb, wsOrdenes, 'Producción Órdenes');

        // Hoja Adelantos
        const wsAdelantos = utils.json_to_sheet((data.adelantos || []).map(a => ({
            'Fecha': a.fechaDisplay || a.fecha,
            'Cuadrilla': a.cuadrilla,
            'Monto': fmtNum(a.monto),
            'Observaciones': a.observaciones || ''
        })));
        utils.book_append_sheet(wb, wsAdelantos, 'Adelantos');

        // Hoja Combustible
        const wsCombustible = utils.json_to_sheet((data.combustible || []).map(c => ({
            'Fecha': c.fechaDisplay || c.fecha,
            'Cuadrilla': c.cuadrilla,
            'Litros': c.litros,
            'Total': fmtNum(c.total),
            'Estación': c.estacion || ''
        })));
        utils.book_append_sheet(wb, wsCombustible, 'Combustible');

        // Hoja Garantías
        const wsGarantias = utils.json_to_sheet((data.garantias || []).map(g => {
            const d = g[0] || g["0"] || g;
            return {
                'WO / Cita': d.workOrder || d.nroCita || '',
                'OT': d.nroOt || '',
                'Contrato': d.contrato || '',
                'Cliente': d.cliente || '',
                'Fecha': moment(d.date, "YYYYMMDD").format("DD/MM/YYYY"),
                'Descuento Garantía (Gs.)': calculateOrderPayout(d, pct)
            };
        }));
        utils.book_append_sheet(wb, wsGarantias, 'Garantias');

        // Hoja Descuentos
        const wsDescuentos = utils.json_to_sheet((data.descuentos || []).map(d => ({
            'Fecha': d.fechaDisplay || d.fecha,
            'Cuadrilla': d.cuadrilla,
            'Tipo': d.tipo,
            'Monto': fmtNum(d.monto),
            'Observaciones': d.observaciones || ''
        })));
        utils.book_append_sheet(wb, wsDescuentos, 'Descuentos y Bonificaciones');

        // Hoja Herramientas
        const wsHerramientas = utils.json_to_sheet((data.herramientasStock || []).map(h => ({
            'Fecha': h.fechaDisplay || h.fecha,
            'Movimiento': h.tipo === 'salida' ? 'Entrega' : 'Devolución',
            'Herramienta': h.herramientaNombre || h.nombre,
            'Marca': h.herramientaMarca || h.marca || '',
            'Cantidad': h.cantidad,
            'Precio Unit.': fmtNum(h.herramientaPrecio || h.precio),
            'Subtotal': fmtNum((h.tipo === 'salida' ? 1 : -1) * h.cantidad * (h.herramientaPrecio || h.precio || 0))
        })));
        utils.book_append_sheet(wb, wsHerramientas, 'Herramientas');

        // Hoja Resumen
        const wsResumen = utils.aoa_to_sheet([
            ['Resumen de Producción Mensual'],
            [],
            ['Cuadrilla', cuadrilla.numero],
            ['Período', periodo],
            [],
            ['Total Producción (sin IVA)', fmtNum(totales.totalSinIva)],
            ['Total Producción (con IVA 10%)', fmtNum(totales.totalConIva)],
            ['(+) Total Bonificaciones', fmtNum(totales.totalBonificaciones)],
            ['(-) Total Adelantos', fmtNum(totales.totalAdelantos)],
            ['(-) Total Combustible', fmtNum(totales.totalCombustible)],
            ['(-) Total Garantías', fmtNum(totales.totalGarantias)],
            ['(-) Total Descuentos', fmtNum(totales.totalDescuentos)],
            ['(-) Total Herramientas', fmtNum(totales.totalHerramientas)],
            ['= Neto a Pagar', fmtNum(totales.neto)],
            ['Total a Facturar', fmtNum(totales.totalFacturar)]
        ]);
        utils.book_append_sheet(wb, wsResumen, 'Resumen');

        writeFile(wb, `produccion-${cuadrilla.numero.replace(/\s+/g, '-')}-${moment().format("YYYYMMDD")}.xlsx`);
    };

    // Exportar Excel (1 o múltiples cuadrillas)
    const handleExportExcel = (specificCuadrillaId = null) => {
        if (!processedReports) return;
        const periodo = `${moment(state.dateFrom).format("DD/MM/YYYY")} - ${moment(state.dateTo).format("DD/MM/YYYY")}`;

        if (specificCuadrillaId) {
            const report = processedReports.reportsByCuadrilla.find(r => r.cuadrilla.id === specificCuadrillaId);
            if (report) exportSingleCuadrillaExcel(report, periodo);
            return;
        }

        // Si se seleccionó 1 sola cuadrilla
        if (processedReports.reportsByCuadrilla.length === 1) {
            exportSingleCuadrillaExcel(processedReports.reportsByCuadrilla[0], periodo);
            return;
        }

        // Múltiples cuadrillas: Hoja de Resumen General + Hoja por cada Cuadrilla
        const wb = utils.book_new();

        // 1. Hoja "Resumen General"
        const resumenGeneralRows = processedReports.reportsByCuadrilla.map(r => ({
            'Cuadrilla': r.cuadrilla.numero,
            'Usuario': r.cuadrilla.usuario || '',
            'Órdenes Producidas': r.data.ordenes.filter(o => !!checkOverrides[o.id]).length,
            'Órdenes Anuladas': r.data.ordenes.filter(o => !checkOverrides[o.id]).length,
            'Prod. sin IVA': fmtNum(r.totales.totalSinIva),
            'Prod. con IVA (10%)': fmtNum(r.totales.totalConIva),
            '(+) Bonificaciones': fmtNum(r.totales.totalBonificaciones),
            '(-) Adelantos': fmtNum(r.totales.totalAdelantos),
            '(-) Combustible': fmtNum(r.totales.totalCombustible),
            '(-) Garantías': fmtNum(r.totales.totalGarantias),
            '(-) Descuentos': fmtNum(r.totales.totalDescuentos),
            '(-) Herramientas': fmtNum(r.totales.totalHerramientas),
            '(=) NETO A PAGAR': fmtNum(r.totales.neto),
            'TOTAL A FACTURAR': fmtNum(r.totales.totalFacturar)
        }));

        // Fila Total General
        resumenGeneralRows.push({
            'Cuadrilla': 'TOTAL GENERAL',
            'Usuario': '',
            'Órdenes Producidas': processedReports.globalTotales.totalOrdenesLiquidadas,
            'Órdenes Anuladas': processedReports.globalTotales.totalOrdenes - processedReports.globalTotales.totalOrdenesLiquidadas,
            'Prod. sin IVA': fmtNum(processedReports.globalTotales.totalSinIva),
            'Prod. con IVA (10%)': fmtNum(processedReports.globalTotales.totalConIva),
            '(+) Bonificaciones': fmtNum(processedReports.globalTotales.totalBonificaciones),
            '(-) Adelantos': fmtNum(processedReports.globalTotales.totalAdelantos),
            '(-) Combustible': fmtNum(processedReports.globalTotales.totalCombustible),
            '(-) Garantías': fmtNum(processedReports.globalTotales.totalGarantias),
            '(-) Descuentos': fmtNum(processedReports.globalTotales.totalDescuentos),
            '(-) Herramientas': fmtNum(processedReports.globalTotales.totalHerramientas),
            '(=) NETO A PAGAR': fmtNum(processedReports.globalTotales.neto),
            'TOTAL A FACTURAR': fmtNum(processedReports.globalTotales.totalFacturar)
        });

        const wsResumenGen = utils.json_to_sheet(resumenGeneralRows);
        utils.book_append_sheet(wb, wsResumenGen, 'Resumen General');

        // 2. Hojas individuales por cada cuadrilla
        processedReports.reportsByCuadrilla.forEach(r => {
            const rawSheetName = (r.cuadrilla.numero || 'Cuadrilla').replace(/[:\\/?*[\]]/g, '').trim().slice(0, 31);
            let sheetName = rawSheetName;
            let counter = 1;
            while (wb.SheetNames.includes(sheetName)) {
                sheetName = `${rawSheetName.slice(0, 28)}_${counter++}`;
            }

            const rows = [];

            // Encabezado Cuadrilla
            rows.push(['PRODUCCIÓN MENSUAL', '', '', '', '', '', '', '']);
            rows.push(['Cuadrilla:', r.cuadrilla.numero, 'Usuario:', r.cuadrilla.usuario || '', '', '', '']);
            rows.push(['Período:', periodo, '', '', '', '', '', '']);
            rows.push([]);

            // Resumen de la cuadrilla
            rows.push(['RESUMEN DE PRODUCCIÓN', 'MONTO (Gs.)']);
            rows.push(['Producción sin IVA', fmtNum(r.totales.totalSinIva)]);
            rows.push(['Producción con IVA (10%)', fmtNum(r.totales.totalConIva)]);
            rows.push(['(+) Bonificaciones', fmtNum(r.totales.totalBonificaciones)]);
            rows.push(['(-) Adelantos', fmtNum(r.totales.totalAdelantos)]);
            rows.push(['(-) Combustible', fmtNum(r.totales.totalCombustible)]);
            rows.push(['(-) Garantías', fmtNum(r.totales.totalGarantias)]);
            rows.push(['(-) Descuentos', fmtNum(r.totales.totalDescuentos)]);
            rows.push(['(-) Herramientas', fmtNum(r.totales.totalHerramientas)]);
            rows.push(['NETO A PAGAR', fmtNum(r.totales.neto)]);
            rows.push(['TOTAL A FACTURAR', fmtNum(r.totales.totalFacturar)]);
            rows.push([]);

            // Sección Órdenes
            rows.push(['ÓRDENES DE TRABAJO']);
            rows.push(['Item', 'WO / Cita', 'OT', 'Contrato', 'Cliente', 'Fecha', 'Estado', 'Motivo de Anulación', 'Subtotal Pago (Gs.)']);
            (r.data.ordenes || []).forEach((o, idx) => {
                const isActive = !!checkOverrides[o.id];
                const payout = isActive ? calculateOrderPayout(o, r.pct) : 0;
                const motivo = !isActive ? (motivosOverrides[o.id] || o.motivoAnulacion || 'No descargó materiales') : '';

                rows.push([
                    idx + 1,
                    o.workOrder || o.nroCita || '',
                    o.nroOt || '',
                    o.contrato || '',
                    o.cliente || '',
                    moment(o.date, "YYYYMMDD").format("DD/MM/YYYY"),
                    isActive ? 'PRODUCIDA' : 'ANULADA',
                    motivo,
                    fmtNum(payout)
                ]);
            });
            rows.push([]);

            // Sección Adelantos
            rows.push(['ADELANTOS']);
            rows.push(['Fecha', 'Cuadrilla', 'Monto', 'Observaciones']);
            (r.data.adelantos || []).forEach(a => {
                rows.push([a.fechaDisplay || a.fecha, a.cuadrilla, fmtNum(a.monto), a.observaciones || '']);
            });
            rows.push([]);

            // Sección Combustible
            rows.push(['COMBUSTIBLE']);
            rows.push(['Fecha', 'Patente', 'Producto', 'Litros', 'Precio Unit.', 'Total']);
            (r.data.combustible || []).forEach(c => {
                rows.push([c.fechaDisplay || c.fecha, c.patente, c.producto, c.litros, fmtNum(c.precioUnitario), fmtNum(c.total)]);
            });
            rows.push([]);

            // Sección Garantías
            rows.push(['GARANTÍAS A DESCONTAR']);
            rows.push(['Contrato', 'OT', 'Cliente', 'Fecha', 'Descuento (Gs.)']);
            (r.data.garantias || []).forEach(g => {
                const d = g[0] || g["0"] || g;
                rows.push([
                    d.contrato || '',
                    d.nroOt || '',
                    d.cliente || '',
                    moment(d.date, "YYYYMMDD").format("DD/MM/YYYY"),
                    fmtNum(calculateOrderPayout(d, r.pct))
                ]);
            });
            rows.push([]);

            // Sección Descuentos
            rows.push(['DESCUENTOS Y BONIFICACIONES']);
            rows.push(['Fecha', 'Tipo', 'Monto', 'Observaciones']);
            (r.data.descuentos || []).forEach(d => {
                rows.push([d.fechaDisplay || d.fecha, d.tipo, fmtNum(d.monto), d.observaciones || '']);
            });
            rows.push([]);

            // Sección Herramientas
            rows.push(['HERRAMIENTAS']);
            rows.push(['Fecha', 'Movimiento', 'Herramienta', 'Marca', 'Cantidad', 'Precio Unit.', 'Subtotal']);
            (r.data.herramientasStock || []).forEach(h => {
                rows.push([
                    h.fechaDisplay || h.fecha,
                    h.tipo === 'salida' ? 'Entrega' : 'Devolución',
                    h.herramientaNombre || h.nombre,
                    h.herramientaMarca || h.marca || '',
                    h.cantidad,
                    fmtNum(h.herramientaPrecio || h.precio),
                    fmtNum((h.tipo === 'salida' ? 1 : -1) * h.cantidad * (h.herramientaPrecio || h.precio || 0))
                ]);
            });

            const wsCuadrilla = utils.aoa_to_sheet(rows);
            utils.book_append_sheet(wb, wsCuadrilla, sheetName);
        });

        writeFile(wb, `produccion-consolidada-${moment().format("YYYYMMDD")}.xlsx`);
    };

    // Generador de PDF vectorial real con jsPDF y jspdf-autotable
    const buildCuadrillaPDFDoc = (cuadrillaReport, periodo) => {
        const { cuadrilla, data, totales, pct } = cuadrillaReport;
        const doc = new jsPDF({ orientation: 'p', unit: 'mm', format: 'a4' });
        const pageWidth = doc.internal.pageSize.getWidth();

        // Estilos y paleta
        const primaryColor = [21, 101, 192];
        const secondaryColor = [74, 20, 140];
        const warningColor = [230, 81, 0];
        const errorColor = [198, 40, 40];
        const successColor = [46, 125, 50];

        // Encabezado Principal
        doc.setFillColor(...primaryColor);
        doc.rect(0, 0, pageWidth, 24, 'F');

        doc.setTextColor(255, 255, 255);
        doc.setFontSize(16);
        doc.setFont('helvetica', 'bold');
        doc.text('PRODUCCIÓN MENSUAL DE CUADRILLAS', pageWidth / 2, 11, { align: 'center' });

        doc.setFontSize(10);
        doc.setFont('helvetica', 'normal');
        doc.text(`Período: ${periodo}`, pageWidth / 2, 18, { align: 'center' });

        // Info Cuadrilla Card
        let currentY = 30;
        doc.setFillColor(245, 248, 255);
        doc.roundedRect(14, currentY, pageWidth - 28, 18, 2, 2, 'F');
        doc.setDrawColor(200, 220, 245);
        doc.roundedRect(14, currentY, pageWidth - 28, 18, 2, 2, 'D');

        doc.setTextColor(33, 33, 33);
        doc.setFontSize(11);
        doc.setFont('helvetica', 'bold');
        doc.text(`Cuadrilla: ${cuadrilla.numero} ${cuadrilla.usuario ? `(${cuadrilla.usuario})` : ''}`, 18, currentY + 7);

        doc.setFontSize(9);
        doc.setFont('helvetica', 'normal');
        const prodCount = (data.ordenes || []).filter(o => !!checkOverrides[o.id]).length;
        const anulCount = (data.ordenes || []).filter(o => !checkOverrides[o.id]).length;
        doc.text(`Órdenes: ${prodCount} Producidas / ${anulCount} Anuladas`, 18, currentY + 13);

        currentY += 24;

        // Helper para dibujar encabezados de sección con barra de acento de color
        const drawSectionHeader = (title, color) => {
            if (currentY > 220) {
                doc.addPage();
                currentY = 20;
            }
            // Barra vertical de acento
            doc.setFillColor(...color);
            doc.rect(14, currentY, 3.5, 6, 'F');

            // Texto del título del apartado
            doc.setFontSize(10.5);
            doc.setFont('helvetica', 'bold');
            doc.setTextColor(...color);
            doc.text(title, 19.5, currentY + 4.7);

            currentY += 8.5;
        };

        // 1. Tabla Comisiones por Órdenes (Incluye activas y anuladas tachadas con valor 0)
        drawSectionHeader('Órdenes de Trabajo', primaryColor);

        const ordenesBody = (data.ordenes || []).map((o, idx) => {
            const isActive = !!checkOverrides[o.id];
            const payout = isActive ? calculateOrderPayout(o, pct) : 0;
            const motivo = !isActive ? (motivosOverrides[o.id] || o.motivoAnulacion || 'No descargó materiales') : '';

            const clientText = isActive
                ? (o.cliente || '')
                : (o.cliente ? `${o.cliente}\n[ANULADA: ${motivo}]` : `[ANULADA: ${motivo}]`);

            return [
                idx + 1,
                o.nroFormulario || o.workOrder || '',
                o.contrato || '',
                o.nroOt || '',
                clientText,
                moment(o.date, "YYYYMMDD").format("DD/MM/YYYY"),
                isActive ? fmt(payout) : '₲ 0'
            ];
        });

        if (ordenesBody.length === 0) {
            ordenesBody.push([{ content: 'Sin órdenes registradas en el período', colSpan: 7, styles: { halign: 'center', textColor: [120, 120, 120] } }]);
        }

        autoTable(doc, {
            startY: currentY,
            head: [['#', 'Formulario / WO', 'Contrato', 'OT', 'Cliente / Estado', 'Fecha', 'Subtotal']],
            body: ordenesBody,
            foot: [
                ['', '', '', '', 'Total Sin IVA:', '', fmt(totales.totalSinIva)],
                ['', '', '', '', 'Total Con IVA (10%):', '', fmt(totales.totalConIva)]
            ],
            showFoot: 'lastPage',
            theme: 'grid',
            headStyles: { fillColor: primaryColor, textColor: 255, fontStyle: 'bold', fontSize: 8 },
            footStyles: { fillColor: [235, 245, 255], textColor: [21, 101, 192], fontStyle: 'bold', fontSize: 8 },
            bodyStyles: { fontSize: 7.5 },
            columnStyles: {
                0: { cellWidth: 8, halign: 'center' },
                5: { halign: 'center' },
                6: { halign: 'right', fontStyle: 'bold' }
            },
            didParseCell: (hookData) => {
                if (hookData.section === 'body') {
                    const rowIndex = hookData.row.index;
                    const order = (data.ordenes || [])[rowIndex];
                    if (order && !checkOverrides[order.id]) {
                        // Fila anulada: estilo atenuado/rojo suave
                        hookData.cell.styles.textColor = [160, 160, 160];
                        if (hookData.column.index === 6) {
                            hookData.cell.styles.textColor = [211, 47, 47];
                        }
                    }
                }
            },
            margin: { left: 14, right: 14 }
        });

        currentY = doc.lastAutoTable.finalY + 8;

        // 2. Tabla Adelantos
        drawSectionHeader('Adelantos', errorColor);
        const adelantosBody = (data.adelantos || []).map(a => [
            a.fechaDisplay || a.fecha,
            a.cuadrilla || '',
            fmt(a.monto),
            a.observaciones || ''
        ]);
        if (adelantosBody.length === 0) {
            adelantosBody.push([{ content: 'Sin adelantos registrados', colSpan: 4, styles: { halign: 'center', textColor: [120, 120, 120] } }]);
        }

        autoTable(doc, {
            startY: currentY,
            head: [['Fecha', 'Cuadrilla', 'Monto Adelanto', 'Observaciones']],
            body: adelantosBody,
            foot: [['', 'Total Adelantos:', fmt(totales.totalAdelantos), '']],
            showFoot: 'lastPage',
            theme: 'grid',
            headStyles: { fillColor: errorColor, textColor: 255, fontStyle: 'bold', fontSize: 8 },
            footStyles: { fillColor: [255, 235, 235], textColor: errorColor, fontStyle: 'bold', fontSize: 8 },
            bodyStyles: { fontSize: 7.5 },
            columnStyles: { 2: { halign: 'right', fontStyle: 'bold' } },
            margin: { left: 14, right: 14 }
        });

        currentY = doc.lastAutoTable.finalY + 8;

        // 3. Tabla Combustible
        drawSectionHeader('Combustible', warningColor);
        const combustibleBody = (data.combustible || []).map(c => [
            c.fechaDisplay || c.fecha,
            c.patente || '',
            c.producto || '',
            c.litros || '',
            fmt(c.precioUnitario),
            fmt(c.total)
        ]);
        if (combustibleBody.length === 0) {
            combustibleBody.push([{ content: 'Sin registros de combustible', colSpan: 6, styles: { halign: 'center', textColor: [120, 120, 120] } }]);
        }

        autoTable(doc, {
            startY: currentY,
            head: [['Fecha', 'Patente', 'Producto', 'Litros', 'Precio Unit.', 'Total']],
            body: combustibleBody,
            foot: [['', '', '', '', 'Total Combustible:', fmt(totales.totalCombustible)]],
            showFoot: 'lastPage',
            theme: 'grid',
            headStyles: { fillColor: warningColor, textColor: 255, fontStyle: 'bold', fontSize: 8 },
            footStyles: { fillColor: [255, 243, 224], textColor: warningColor, fontStyle: 'bold', fontSize: 8 },
            bodyStyles: { fontSize: 7.5 },
            columnStyles: { 4: { halign: 'right' }, 5: { halign: 'right', fontStyle: 'bold' } },
            margin: { left: 14, right: 14 }
        });

        currentY = doc.lastAutoTable.finalY + 8;

        // 4. Tabla Garantías
        drawSectionHeader('Garantías a Descontar', secondaryColor);
        const garantiasBody = (data.garantias || []).map(g => {
            const d = g[0] || g["0"] || g;
            return [
                d.contrato || 'N/A',
                d.nroOt || 'N/A',
                d.cliente || 'N/A',
                moment(d.date, "YYYYMMDD").format("DD/MM/YYYY"),
                fmt(calculateOrderPayout(d, pct))
            ];
        });
        if (garantiasBody.length === 0) {
            garantiasBody.push([{ content: 'Sin garantías registradas', colSpan: 5, styles: { halign: 'center', textColor: [120, 120, 120] } }]);
        }

        autoTable(doc, {
            startY: currentY,
            head: [['Contrato', 'Nro OT', 'Cliente', 'Fecha', 'Descuento Garantía']],
            body: garantiasBody,
            foot: [['', '', '', 'Total Garantías:', fmt(totales.totalGarantias)]],
            showFoot: 'lastPage',
            theme: 'grid',
            headStyles: { fillColor: secondaryColor, textColor: 255, fontStyle: 'bold', fontSize: 8 },
            footStyles: { fillColor: [243, 229, 245], textColor: secondaryColor, fontStyle: 'bold', fontSize: 8 },
            bodyStyles: { fontSize: 7.5 },
            columnStyles: { 4: { halign: 'right', fontStyle: 'bold' } },
            margin: { left: 14, right: 14 }
        });

        currentY = doc.lastAutoTable.finalY + 8;

        // 5. Tabla Descuentos / Bonificaciones
        drawSectionHeader('Descuentos / Bonificaciones', [106, 27, 154]);
        const descuentosBody = (data.descuentos || []).map(d => {
            const isBonif = String(d.tipo || '').toUpperCase().includes('BONIFICACION');
            return [
                d.fechaDisplay || d.fecha,
                d.tipo || '',
                isBonif ? `+ ${fmt(d.monto)}` : `- ${fmt(d.monto)}`,
                d.observaciones || ''
            ];
        });
        if (descuentosBody.length === 0) {
            descuentosBody.push([{ content: 'Sin descuentos ni bonificaciones', colSpan: 4, styles: { halign: 'center', textColor: [120, 120, 120] } }]);
        }

        autoTable(doc, {
            startY: currentY,
            head: [['Fecha', 'Tipo', 'Monto', 'Observaciones']],
            body: descuentosBody,
            foot: [['', `Desc: ${fmt(totales.totalDescuentos)} | Bonif: +${fmt(totales.totalBonificaciones)}`, `Neto: ${fmt(totales.totalBonificaciones - totales.totalDescuentos)}`, '']],
            showFoot: 'lastPage',
            theme: 'grid',
            headStyles: { fillColor: [106, 27, 154], textColor: 255, fontStyle: 'bold', fontSize: 8 },
            footStyles: { fillColor: [243, 229, 245], textColor: [106, 27, 154], fontStyle: 'bold', fontSize: 8 },
            bodyStyles: { fontSize: 7.5 },
            columnStyles: { 2: { halign: 'right', fontStyle: 'bold' } },
            margin: { left: 14, right: 14 }
        });

        currentY = doc.lastAutoTable.finalY + 8;

        // 6. Tabla Herramientas
        drawSectionHeader('Herramientas (Entregas / Devoluciones)', [211, 47, 47]);
        const herramientasBody = (data.herramientasStock || []).map(h => {
            const sub = h.cantidad * (h.herramientaPrecio || h.precio || 0);
            const sign = h.tipo === 'salida' ? '' : '-';
            return [
                h.fechaDisplay || h.fecha,
                h.tipo === 'salida' ? 'Entrega' : 'Devolución',
                h.herramientaNombre || h.nombre || '',
                h.cantidad,
                fmt(h.herramientaPrecio || h.precio),
                `${sign}${fmt(sub)}`
            ];
        });
        if (herramientasBody.length === 0) {
            herramientasBody.push([{ content: 'Sin movimientos de herramientas en el período', colSpan: 6, styles: { halign: 'center', textColor: [120, 120, 120] } }]);
        }

        autoTable(doc, {
            startY: currentY,
            head: [['Fecha', 'Movimiento', 'Herramienta', 'Cant.', 'Precio Unit.', 'Subtotal']],
            body: herramientasBody,
            foot: [['', '', '', '', 'Total Herramientas:', fmt(totales.totalHerramientas)]],
            showFoot: 'lastPage',
            theme: 'grid',
            headStyles: { fillColor: [211, 47, 47], textColor: 255, fontStyle: 'bold', fontSize: 8 },
            footStyles: { fillColor: [255, 235, 238], textColor: [211, 47, 47], fontStyle: 'bold', fontSize: 8 },
            bodyStyles: { fontSize: 7.5 },
            columnStyles: { 3: { halign: 'center' }, 4: { halign: 'right' }, 5: { halign: 'right', fontStyle: 'bold' } },
            margin: { left: 14, right: 14 }
        });

        currentY = doc.lastAutoTable.finalY + 10;

        // 7. Resumen Financiero Final en Cuadro
        if (currentY > 200) { doc.addPage(); currentY = 20; }

        const summaryWidth = 110;
        const summaryX = pageWidth - summaryWidth - 14;

        doc.setFillColor(250, 250, 250);
        doc.setDrawColor(21, 101, 192);
        doc.setLineWidth(0.6);
        doc.roundedRect(summaryX, currentY, summaryWidth, 82, 2, 2, 'FD');

        doc.setTextColor(21, 101, 192);
        doc.setFontSize(11);
        doc.setFont('helvetica', 'bold');
        doc.text('RESUMEN DE PRODUCCIÓN', summaryX + summaryWidth / 2, currentY + 7, { align: 'center' });

        doc.setFontSize(8);
        doc.setFont('helvetica', 'normal');
        doc.setTextColor(60, 60, 60);

        let rowY = currentY + 14;
        const addSummaryLine = (label, val, valColor = [60, 60, 60], isBold = false) => {
            doc.setFont('helvetica', isBold ? 'bold' : 'normal');
            doc.setTextColor(60, 60, 60);
            doc.text(label, summaryX + 6, rowY);
            doc.setTextColor(...valColor);
            doc.text(val, summaryX + summaryWidth - 6, rowY, { align: 'right' });
            rowY += 5.5;
        };

        addSummaryLine('Producción sin IVA', fmt(totales.totalSinIva));
        addSummaryLine('Producción con IVA (10%)', fmt(totales.totalConIva));
        addSummaryLine('(+) Bonificaciones', `+ ${fmt(totales.totalBonificaciones)}`, successColor);
        addSummaryLine('(-) Adelantos', `- ${fmt(totales.totalAdelantos)}`, errorColor);
        addSummaryLine('(-) Combustible', `- ${fmt(totales.totalCombustible)}`, errorColor);
        addSummaryLine('(-) Garantías', `- ${fmt(totales.totalGarantias)}`, errorColor);
        addSummaryLine('(-) Descuentos', `- ${fmt(totales.totalDescuentos)}`, errorColor);
        addSummaryLine('(-) Herramientas', `- ${fmt(totales.totalHerramientas)}`, errorColor);

        // Barra Neto a Pagar
        doc.setFillColor(totales.neto >= 0 ? 232 : 255, totales.neto >= 0 ? 245 : 235, totales.neto >= 0 ? 233 : 235);
        doc.rect(summaryX + 2, rowY - 1, summaryWidth - 4, 7, 'F');
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(9);
        doc.setTextColor(totales.neto >= 0 ? 46 : 198, totales.neto >= 0 ? 125 : 40, totales.neto >= 0 ? 50 : 40);
        doc.text('NETO A PAGAR:', summaryX + 6, rowY + 4);
        doc.text(fmt(totales.neto), summaryX + summaryWidth - 6, rowY + 4, { align: 'right' });

        rowY += 8.5;

        // Barra Total a Facturar
        doc.setFillColor(227, 242, 253);
        doc.rect(summaryX + 2, rowY - 1, summaryWidth - 4, 7, 'F');
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(9);
        doc.setTextColor(21, 101, 192);
        doc.text('TOTAL A FACTURAR:', summaryX + 6, rowY + 4);
        doc.text(fmt(totales.totalFacturar), summaryX + summaryWidth - 6, rowY + 4, { align: 'right' });

        // Pie de página
        const totalPages = doc.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
            doc.setPage(i);
            doc.setFontSize(8);
            doc.setTextColor(150, 150, 150);
            doc.setFont('helvetica', 'normal');
            doc.text(`Cuadrilla: ${cuadrilla.numero} | Período: ${periodo}`, 14, doc.internal.pageSize.getHeight() - 8);
        }

        return doc;
    };

    // Descargar PDF de una sola cuadrilla
    const handleExportSinglePDF = (cuadrillaId) => {
        if (!processedReports) return;
        const periodo = `${moment(state.dateFrom).format("DD/MM/YYYY")} - ${moment(state.dateTo).format("DD/MM/YYYY")}`;
        const report = processedReports.reportsByCuadrilla.find(r => r.cuadrilla.id === cuadrillaId);
        if (!report) return;

        const doc = buildCuadrillaPDFDoc(report, periodo);
        doc.save(`produccion-${report.cuadrilla.numero.replace(/\s+/g, '-')}-${moment().format("YYYYMMDD")}.pdf`);
        setSnackbarInfo({ open: true, text: `PDF descargado: ${report.cuadrilla.numero}`, type: 'success' });
    };

    // Descargar PDFs de todas las cuadrillas seleccionadas (archivos separados)
    const handleExportAllPDFs = () => {
        if (!processedReports) return;
        const periodo = `${moment(state.dateFrom).format("DD/MM/YYYY")} - ${moment(state.dateTo).format("DD/MM/YYYY")}`;

        processedReports.reportsByCuadrilla.forEach((report, index) => {
            setTimeout(() => {
                const doc = buildCuadrillaPDFDoc(report, periodo);
                doc.save(`produccion-${report.cuadrilla.numero.replace(/\s+/g, '-')}-${moment().format("YYYYMMDD")}.pdf`);
            }, index * 350);
        });

        setSnackbarInfo({
            open: true,
            text: `Descargando ${processedReports.reportsByCuadrilla.length} archivos PDF independientes...`,
            type: 'info'
        });
    };

    // Descargar todos los PDFs empaquetados en un archivo ZIP
    const handleExportZip = async () => {
        if (!processedReports) return;
        setDownloadingZip(true);
        const periodo = `${moment(state.dateFrom).format("DD/MM/YYYY")} - ${moment(state.dateTo).format("DD/MM/YYYY")}`;

        try {
            const zip = new JSZip();

            processedReports.reportsByCuadrilla.forEach((report) => {
                const doc = buildCuadrillaPDFDoc(report, periodo);
                const pdfBlob = doc.output('blob');
                const fileName = `produccion-${report.cuadrilla.numero.replace(/\s+/g, '-')}-${moment().format("YYYYMMDD")}.pdf`;
                zip.file(fileName, pdfBlob);
            });

            const zipBlob = await zip.generateAsync({ type: 'blob' });
            const url = URL.createObjectURL(zipBlob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `produccion-cuadrillas-${moment().format("YYYYMMDD")}.zip`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);

            setSnackbarInfo({
                open: true,
                text: `Archivo ZIP descargado con ${processedReports.reportsByCuadrilla.length} reportes PDF`,
                type: 'success'
            });
        } catch (error) {
            console.error('Error al generar ZIP:', error);
            setSnackbarInfo({ open: true, text: `Error al generar ZIP: ${error.message}`, type: 'error' });
        } finally {
            setDownloadingZip(false);
        }
    };

    // Normaliza un número de teléfono al formato internacional de WhatsApp (ej: 0981123456 -> 595981123456)
    const formatPhoneForWhatsapp = (rawPhone) => {
        if (!rawPhone) return '';
        let digits = String(rawPhone).replace(/\D/g, '');
        if (!digits) return '';
        if (digits.startsWith('00')) {
            digits = digits.slice(2);
        }
        // Formato local de Paraguay: 09XXXXXXXX (10 dígitos) -> 5959XXXXXXXX
        if (digits.startsWith('09') && digits.length >= 9 && digits.length <= 11) {
            return `595${digits.slice(1)}`;
        }
        // Formato celular sin el 0 inicial: 9XXXXXXXX (9 dígitos) -> 5959XXXXXXXX
        if (digits.startsWith('9') && digits.length === 9) {
            return `595${digits}`;
        }
        // Si empieza con un solo 0 y no tiene código de país, quitar el 0 y anteponer 595
        if (digits.startsWith('0') && digits.length > 6) {
            return `595${digits.slice(1)}`;
        }
        return digits;
    };

    // Construye el mensaje resumen de liquidación para WhatsApp (incluyendo el link directo al PDF en Firebase Storage)
    const buildWhatsappMessage = (report, periodo, pdfUrl = '') => {
        const { cuadrilla, totales } = report;
        const lines = [
            `📄 *LIQUIDACIÓN MENSUAL DE PRODUCCIÓN*`,
            `👷 *Cuadrilla:* ${cuadrilla.numero}${cuadrilla.usuario ? ` (${cuadrilla.usuario})` : ''}`,
            `📅 *Período:* ${periodo}`,
            `────────────────────`,
            `• Producción (con IVA): *${fmt(totales.totalConIva)}*`,
        ];
        if (totales.totalBonificaciones > 0) {
            lines.push(`• (+) Bonificaciones: *+ ${fmt(totales.totalBonificaciones)}*`);
        }
        if (totales.totalAdelantos > 0) {
            lines.push(`• (-) Adelantos: *- ${fmt(totales.totalAdelantos)}*`);
        }
        if (totales.totalCombustible > 0) {
            lines.push(`• (-) Combustible: *- ${fmt(totales.totalCombustible)}*`);
        }
        if (totales.totalGarantias > 0) {
            lines.push(`• (-) Garantías: *- ${fmt(totales.totalGarantias)}*`);
        }
        if (totales.totalDescuentos > 0) {
            lines.push(`• (-) Descuentos: *- ${fmt(totales.totalDescuentos)}*`);
        }
        if (totales.totalHerramientas > 0) {
            lines.push(`• (-) Herramientas: *- ${fmt(totales.totalHerramientas)}*`);
        }
        lines.push(
            `────────────────────`,
            `💰 *NETO A PAGAR: ${fmt(totales.neto)}*`,
            `🧾 *Total a facturar: ${fmt(totales.totalFacturar)}*`
        );
        if (pdfUrl) {
            lines.push(
                ``,
                `📥 *Ver / Descargar Detalle Completo en PDF:*`,
                pdfUrl
            );
        } else {
            lines.push(
                ``,
                `_Se adjunta el detalle completo de la liquidación en formato PDF._`
            );
        }
        return lines.join('\n');
    };

    // Abre el modal de WhatsApp e inicializa los teléfonos desde las cuadrillas
    const handleOpenWhatsappModal = () => {
        if (!processedReports) return;
        wakeUpWhatsappBotServer();
        setWhatsappPhones((prev) => {
            const next = { ...prev };
            processedReports.reportsByCuadrilla.forEach(({ cuadrilla }) => {
                if (next[cuadrilla.id] === undefined) {
                    const freshCuad = cuadrillas.find(c => c.id === cuadrilla.id) || cuadrilla;
                    next[cuadrilla.id] = freshCuad.nroTelefono || freshCuad.telefono || '';
                }
            });
            return next;
        });
        setBulkQueueIndex(null);
        setOpenWhatsappModal(true);
    };

    // Guardar la URL del servidor de Render en Firestore y despertarlo inmediatamente
    const handleSaveBotServerUrl = async () => {
        const cleanUrl = String(botServerUrlInput || '').trim();
        try {
            await setDoc(doc(firestore, 'configuracion', 'whatsapp_bot'), { serverUrl: cleanUrl }, { merge: true });
            if (cleanUrl) {
                wakeUpWhatsappBotServer(cleanUrl);
                setSnackbarInfo({
                    open: true,
                    text: 'URL del servidor guardada. Enviando señal para despertar el servicio...',
                    type: 'success'
                });
            }
            setShowBotConfig(false);
        } catch (err) {
            setSnackbarInfo({ open: true, text: `Error guardando URL: ${err.message}`, type: 'error' });
        }
    };

    // Encola el envío 100% automático del archivo .pdf adjunto a través del Bot en Render (Opción 2)
    const enqueueWhatsappBotJob = async (report, cleanPhone, periodo) => {
        const { cuadrilla } = report;
        const safeName = cuadrilla.numero.replace(/[^a-zA-Z0-9_-]/g, '-').replace(/-+/g, '-');
        const periodKey = `${moment(state.dateFrom).format("YYYYMMDD")}_${moment(state.dateTo).format("YYYYMMDD")}`;
        const fileName = `Liquidacion-${safeName}-${periodKey}.pdf`;

        const pdfDoc = buildCuadrillaPDFDoc(report, periodo);
        if (autoDownloadPdfOnSend) {
            pdfDoc.save(fileName);
        }

        const dataUri = pdfDoc.output('datauristring');
        const pdfBase64 = dataUri.includes('base64,') ? dataUri.split('base64,')[1] : dataUri;
        const caption = buildWhatsappMessage(report, periodo, '');

        setWhatsappStatusMap(prev => ({ ...prev, [cuadrilla.id]: 'queued' }));
        setWhatsappErrorMap(prev => ({ ...prev, [cuadrilla.id]: '' }));

        const jobRef = await addDoc(collection(firestore, 'whatsapp_queue'), {
            cuadrillaId: cuadrilla.id,
            cuadrillaNumero: cuadrilla.numero,
            phone: cleanPhone,
            fileName,
            caption,
            pdfBase64,
            status: 'pending',
            createdAt: Date.now(),
        });

        const unsub = onSnapshot(jobRef, (snap) => {
            if (!snap.exists()) return;
            const d = snap.data();
            if (d.status === 'sending') {
                setWhatsappStatusMap(prev => ({ ...prev, [cuadrilla.id]: 'sending' }));
            } else if (d.status === 'sent') {
                setWhatsappStatusMap(prev => ({ ...prev, [cuadrilla.id]: 'sent' }));
                setWhatsappSentMap(prev => ({ ...prev, [cuadrilla.id]: true }));
                unsub();
            } else if (d.status === 'error') {
                setWhatsappStatusMap(prev => ({ ...prev, [cuadrilla.id]: 'error' }));
                setWhatsappErrorMap(prev => ({ ...prev, [cuadrilla.id]: d.error || 'Error al enviar por el Bot' }));
                unsub();
            }
        });
    };

    // Guarda el número editado en Firestore para que quede persistido en la cuadrilla
    const persistPhoneIfChanged = async (cuadrillaObj, newPhoneRaw) => {
        const trimmed = String(newPhoneRaw || '').trim();
        const currentStored = String(cuadrillaObj.nroTelefono || cuadrillaObj.telefono || '').trim();
        if (trimmed === currentStored) return;
        try {
            setSavingPhoneId(cuadrillaObj.id);
            await updateCuadrillaFirestore(cuadrillaObj.id, { nroTelefono: trimmed });
            setCuadrillas(prev => prev.map(c => c.id === cuadrillaObj.id ? { ...c, nroTelefono: trimmed } : c));
            setSelectedCuadrillas(prev => prev.map(c => c.id === cuadrillaObj.id ? { ...c, nroTelefono: trimmed } : c));
        } catch (err) {
            console.warn('No se pudo actualizar nroTelefono en la cuadrilla:', err);
        } finally {
            setSavingPhoneId(null);
        }
    };

    // Genera el PDF de la cuadrilla, lo sube automáticamente a Firebase Storage y devuelve su URL pública de descarga
    const uploadCuadrillaPdfToStorage = async (report, periodo) => {
        const { cuadrilla } = report;
        const safeName = cuadrilla.numero.replace(/[^a-zA-Z0-9_-]/g, '-').replace(/-+/g, '-');
        const periodKey = `${moment(state.dateFrom).format("YYYYMMDD")}_${moment(state.dateTo).format("YYYYMMDD")}`;
        const fileName = `Liquidacion-${safeName}-${periodKey}.pdf`;

        const pdfDoc = buildCuadrillaPDFDoc(report, periodo);
        if (autoDownloadPdfOnSend) {
            pdfDoc.save(fileName);
        }

        const pdfBlob = pdfDoc.output('blob');
        const fileRef = storageRef(storage, `liquidaciones-pdf/${periodKey}/${fileName}`);
        await uploadBytes(fileRef, pdfBlob, {
            contentType: 'application/pdf',
            contentDisposition: `inline; filename="${fileName}"`
        });
        const downloadUrl = await getDownloadURL(fileRef);
        setWhatsappPdfUrls(prev => ({ ...prev, [cuadrilla.id]: downloadUrl }));
        return downloadUrl;
    };

    // Envía la liquidación de una cuadrilla: si el Bot en Render está conectado lo envía 100% automático como archivo .pdf adjunto; si no, sube a Firebase Storage y abre WhatsApp con el link
    const handleSendSingleWhatsapp = async (report, preUploadedUrl = '', forceLinkMode = false) => {
        if (!report || !state.dateFrom || !state.dateTo) return;
        const { cuadrilla } = report;
        const rawPhone = whatsappPhones[cuadrilla.id] !== undefined
            ? whatsappPhones[cuadrilla.id]
            : (cuadrilla.nroTelefono || cuadrilla.telefono || '');
        const cleanPhone = formatPhoneForWhatsapp(rawPhone);

        if (!cleanPhone || cleanPhone.length < 8) {
            if (!openWhatsappModal) {
                handleOpenWhatsappModal();
                return;
            }
            setSnackbarInfo({
                open: true,
                text: `Ingrese un número de teléfono válido para ${cuadrilla.numero}`,
                type: 'warning'
            });
            return;
        }

        persistPhoneIfChanged(cuadrilla, rawPhone);
        const periodo = `${moment(state.dateFrom).format("DD/MM/YYYY")} - ${moment(state.dateTo).format("DD/MM/YYYY")}`;

        // Opción 2: Si el Bot de WhatsApp en Render está conectado y activo, enviar el archivo .pdf adjunto 100% automático en segundo plano
        if (isBotActive && !forceLinkMode) {
            try {
                await enqueueWhatsappBotJob(report, cleanPhone, periodo);
                setSnackbarInfo({
                    open: true,
                    text: `Enviando PDF adjunto automáticamente por WhatsApp a ${cuadrilla.numero}...`,
                    type: 'info'
                });
            } catch (err) {
                setWhatsappStatusMap(prev => ({ ...prev, [cuadrilla.id]: 'error' }));
                setWhatsappErrorMap(prev => ({ ...prev, [cuadrilla.id]: err.message || 'Error al encolar envío' }));
            }
            return;
        }

        // Opción 1: Si ya tenemos el link subido en esta sesión (ej. desde "Enviar Todos Juntos"), abrir directo sin espera
        const existingUrl = preUploadedUrl || whatsappPdfUrls[cuadrilla.id];
        if (existingUrl) {
            const message = buildWhatsappMessage(report, periodo, existingUrl);
            const waUrl = `https://wa.me/${cleanPhone}?text=${encodeURIComponent(message)}`;
            window.open(waUrl, '_blank', 'noopener,noreferrer');
            setWhatsappStatusMap(prev => ({ ...prev, [cuadrilla.id]: 'sent' }));
            setWhatsappSentMap(prev => ({ ...prev, [cuadrilla.id]: true }));
            return;
        }

        // Abrir pestaña de forma síncrona al clic para evitar bloqueos de popups del navegador mientras se sube el PDF (~0.5s)
        const waWindow = window.open('about:blank', '_blank');
        if (waWindow && waWindow.document) {
            waWindow.document.write(
                '<html><head><title>Preparando Liquidación PDF...</title></head>' +
                '<body style="font-family:sans-serif;display:flex;align-items:center;justify-content:center;height:90vh;color:#128C7E;">' +
                '<div style="text-align:center;"><h3>Subiendo PDF a la nube y abriendo WhatsApp...</h3><p>Por favor aguarde un instante.</p></div>' +
                '</body></html>'
            );
        }

        setWhatsappStatusMap(prev => ({ ...prev, [cuadrilla.id]: 'uploading' }));
        setWhatsappErrorMap(prev => ({ ...prev, [cuadrilla.id]: '' }));

        try {
            const pdfUrl = await uploadCuadrillaPdfToStorage(report, periodo);
            const message = buildWhatsappMessage(report, periodo, pdfUrl);
            const waUrl = `https://wa.me/${cleanPhone}?text=${encodeURIComponent(message)}`;

            if (waWindow && !waWindow.closed) {
                waWindow.location.replace(waUrl);
            } else {
                window.open(waUrl, '_blank', 'noopener,noreferrer');
            }

            setWhatsappStatusMap(prev => ({ ...prev, [cuadrilla.id]: 'sent' }));
            setWhatsappSentMap(prev => ({ ...prev, [cuadrilla.id]: true }));
            setSnackbarInfo({
                open: true,
                text: `PDF subido automáticamente y WhatsApp abierto para ${cuadrilla.numero}`,
                type: 'success'
            });
        } catch (err) {
            console.error('Error subiendo PDF a Firebase Storage:', err);
            setWhatsappStatusMap(prev => ({ ...prev, [cuadrilla.id]: 'error' }));
            setWhatsappErrorMap(prev => ({ ...prev, [cuadrilla.id]: err.message || 'Error subiendo PDF' }));
            if (waWindow && !waWindow.closed) {
                const fallbackMsg = buildWhatsappMessage(report, periodo, '');
                waWindow.location.replace(`https://wa.me/${cleanPhone}?text=${encodeURIComponent(fallbackMsg)}`);
            }
            setSnackbarInfo({
                open: true,
                text: `Advertencia al subir PDF (${err.message}). Se abrió WhatsApp con el resumen.`,
                type: 'warning'
            });
        }
    };

    // Enviar todos juntos: si el Bot está activo encola todos los PDFs automáticamente; si no, sube a Firebase Storage e inicia el envío con link
    const handleSendAllWhatsapp = async () => {
        if (!processedReports) return;
        const validReports = processedReports.reportsByCuadrilla.filter(({ cuadrilla }) => {
            const raw = whatsappPhones[cuadrilla.id] !== undefined
                ? whatsappPhones[cuadrilla.id]
                : (cuadrilla.nroTelefono || cuadrilla.telefono || '');
            return formatPhoneForWhatsapp(raw).length >= 8;
        });

        if (validReports.length === 0) {
            setSnackbarInfo({
                open: true,
                text: 'Ninguna cuadrilla tiene un número de teléfono válido cargado.',
                type: 'warning'
            });
            return;
        }

        const periodo = `${moment(state.dateFrom).format("DD/MM/YYYY")} - ${moment(state.dateTo).format("DD/MM/YYYY")}`;

        // Opción 2: Si el Bot de Render está conectado, encolar todos los envíos 100% automáticos en segundo plano
        if (isBotActive) {
            setSnackbarInfo({
                open: true,
                text: `Encolando envío automático de ${validReports.length} PDF(s) adjuntos por el Bot de WhatsApp...`,
                type: 'info'
            });
            for (const rep of validReports) {
                const raw = whatsappPhones[rep.cuadrilla.id] !== undefined
                    ? whatsappPhones[rep.cuadrilla.id]
                    : (rep.cuadrilla.nroTelefono || rep.cuadrilla.telefono || '');
                const cleanPhone = formatPhoneForWhatsapp(raw);
                persistPhoneIfChanged(rep.cuadrilla, raw);
                try {
                    await enqueueWhatsappBotJob(rep, cleanPhone, periodo);
                } catch (err) {
                    console.error(`Error encolando PDF de ${rep.cuadrilla.numero}:`, err);
                }
            }
            return;
        }

        // Opción 1: Abrir la pestaña de la primera cuadrilla de forma síncrona para que el navegador no la bloquee
        const waWindow = window.open('about:blank', '_blank');
        if (waWindow && waWindow.document) {
            waWindow.document.write(
                '<html><head><title>Subiendo PDFs de Liquidación...</title></head>' +
                '<body style="font-family:sans-serif;display:flex;align-items:center;justify-content:center;height:90vh;color:#128C7E;">' +
                `<div style="text-align:center;"><h3>Subiendo ${validReports.length} PDF(s) a la nube y abriendo WhatsApp...</h3><p>Por favor aguarde un instante.</p></div>` +
                '</body></html>'
            );
        }

        setSnackbarInfo({
            open: true,
            text: `Subiendo ${validReports.length} PDF(s) a la nube automáticamente...`,
            type: 'info'
        });

        const uploadedUrls = {};
        await Promise.all(
            validReports.map(async (rep) => {
                const raw = whatsappPhones[rep.cuadrilla.id] !== undefined
                    ? whatsappPhones[rep.cuadrilla.id]
                    : (rep.cuadrilla.nroTelefono || rep.cuadrilla.telefono || '');
                persistPhoneIfChanged(rep.cuadrilla, raw);
                setWhatsappStatusMap(prev => ({ ...prev, [rep.cuadrilla.id]: 'uploading' }));

                try {
                    const url = await uploadCuadrillaPdfToStorage(rep, periodo);
                    uploadedUrls[rep.cuadrilla.id] = url;
                    setWhatsappStatusMap(prev => ({ ...prev, [rep.cuadrilla.id]: 'ready' }));
                } catch (err) {
                    console.error(`Error subiendo PDF de ${rep.cuadrilla.numero}:`, err);
                    setWhatsappStatusMap(prev => ({ ...prev, [rep.cuadrilla.id]: 'error' }));
                }
            })
        );

        // Abrir el primer WhatsApp con su link de PDF ya incluido
        const firstReport = validReports[0];
        const firstRaw = whatsappPhones[firstReport.cuadrilla.id] ?? (firstReport.cuadrilla.nroTelefono || '');
        const firstPhone = formatPhoneForWhatsapp(firstRaw);
        const firstMsg = buildWhatsappMessage(firstReport, periodo, uploadedUrls[firstReport.cuadrilla.id] || '');
        const firstWaUrl = `https://wa.me/${firstPhone}?text=${encodeURIComponent(firstMsg)}`;

        if (waWindow && !waWindow.closed) {
            waWindow.location.replace(firstWaUrl);
        } else {
            window.open(firstWaUrl, '_blank', 'noopener,noreferrer');
        }

        setWhatsappStatusMap(prev => ({ ...prev, [firstReport.cuadrilla.id]: 'sent' }));
        setWhatsappSentMap(prev => ({ ...prev, [firstReport.cuadrilla.id]: true }));

        if (validReports.length > 1) {
            setBulkQueueIndex(1);
            setSnackbarInfo({
                open: true,
                text: `¡${validReports.length} PDFs subidos a la nube! Se abrió el 1/${validReports.length} con el link del PDF incluido. Usá "Abrir Siguiente WhatsApp" para continuar.`,
                type: 'success'
            });
        } else {
            setBulkQueueIndex(null);
            setSnackbarInfo({
                open: true,
                text: `PDF subido a la nube y WhatsApp abierto para ${firstReport.cuadrilla.numero}`,
                type: 'success'
            });
        }
    };

    const isFormValid = state.dateFrom && state.dateTo && selectedCuadrillas?.length > 0;

    if (!isAdmin) return <ErrorPage />;

    return (
        <Container component="main" maxWidth="lg">
            {/* Formulario de Filtros */}
            <Paper elevation={3} sx={{ p: 3, mt: 2 }}>
                <Typography variant="h5" align="center" gutterBottom fontWeight={600}>
                    Producción Mensual
                </Typography>

                <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mt: 2, alignItems: 'center' }}>
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                        <DatePicker
                            label="Fecha Desde"
                            inputFormat="DD/MM/YYYY"
                            value={state.dateFrom}
                            onChange={onChangeDateFrom}
                            renderInput={(params) => <TextField {...params} sx={{ flex: 1, minWidth: 160 }} />}
                        />
                    </LocalizationProvider>

                    <LocalizationProvider dateAdapter={AdapterMoment}>
                        <DatePicker
                            label="Fecha Hasta"
                            inputFormat="DD/MM/YYYY"
                            value={state.dateTo}
                            onChange={onChangeDateTo}
                            renderInput={(params) => <TextField {...params} sx={{ flex: 1, minWidth: 160 }} />}
                        />
                    </LocalizationProvider>

                    <FormControl sx={{ flex: 2, minWidth: 260 }}>
                        <Autocomplete
                            multiple
                            disableCloseOnSelect
                            options={cuadrillas}
                            value={selectedCuadrillas}
                            onChange={(_, v) => {
                                setSelectedCuadrillas(v);
                                setRawReportData(null);
                            }}
                            getOptionLabel={(o) => o.usuario ? `${o.usuario} - ${o.numero}` : (o.numero || '')}
                            isOptionEqualToValue={(option, value) => option.id === value.id}
                            renderOption={(props, option, { selected }) => (
                                <li {...props}>
                                    <Checkbox
                                        icon={iconCheckbox}
                                        checkedIcon={checkedIconCheckbox}
                                        style={{ marginRight: 8 }}
                                        checked={selected}
                                    />
                                    {option.usuario ? `${option.usuario} - ${option.numero}` : option.numero}
                                </li>
                            )}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Cuadrillas"
                                    placeholder={selectedCuadrillas.length === 0 ? "Seleccionar cuadrillas..." : ""}
                                />
                            )}
                        />
                    </FormControl>

                    <Button
                        variant="contained"
                        size="large"
                        startIcon={loading ? <CircularProgress size={18} color="inherit" /> : <SearchIcon />}
                        onClick={handleGenerar}
                        disabled={!isFormValid || loading}
                        sx={{ minWidth: 140, height: 54 }}
                    >
                        {loading ? 'Cargando...' : 'Generar'}
                    </Button>
                </Box>

                {/* Botones de acción rápida para selección */}
                <Box sx={{ display: 'flex', gap: 1, mt: 1.5, alignItems: 'center' }}>
                    <Button
                        size="small"
                        variant="text"
                        startIcon={<SelectAllIcon />}
                        onClick={handleSelectAllCuadrillas}
                    >
                        Seleccionar Todas ({cuadrillas.length})
                    </Button>
                    <Button
                        size="small"
                        variant="text"
                        color="inherit"
                        startIcon={<ClearAllIcon />}
                        onClick={handleClearCuadrillas}
                        disabled={selectedCuadrillas.length === 0}
                    >
                        Limpiar
                    </Button>
                    {selectedCuadrillas.length > 0 && (
                        <Typography variant="body2" color="text.secondary" sx={{ ml: 'auto' }}>
                            {selectedCuadrillas.length} cuadrilla(s) seleccionada(s)
                        </Typography>
                    )}
                </Box>

                {alertValidationDate && (
                    <MuiAlert severity="error" sx={{ mt: 2 }}>{alertValidationDate}</MuiAlert>
                )}
            </Paper>

            {/* Visualización de Reportes */}
            {processedReports && (
                <Box sx={{ mt: 3, mb: 5 }}>
                    {/* Resumen General Consolidado */}
                    <Paper
                        elevation={3}
                        sx={{
                            p: 3,
                            mb: 3,
                            borderRadius: 2,
                            borderLeft: '6px solid #1976d2',
                            backgroundColor: '#f8fbff'
                        }}
                    >
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2, mb: 2 }}>
                            <Box>
                                <Typography variant="h6" fontWeight={700} color="primary.main">
                                    Resumen General Consolidado
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    Período: {moment(state.dateFrom).format("DD/MM/YYYY")} — {moment(state.dateTo).format("DD/MM/YYYY")} &nbsp;|&nbsp; {processedReports.reportsByCuadrilla.length} Cuadrilla(s)
                                </Typography>
                            </Box>

                            {/* Botones de exportación global */}
                            <Stack direction="row" spacing={1} flexWrap="wrap">
                                <Button
                                    variant="outlined"
                                    size="small"
                                    startIcon={<FileDownloadIcon />}
                                    onClick={() => handleExportExcel()}
                                >
                                    Excel {processedReports.reportsByCuadrilla.length > 1 ? 'Multi-Hoja' : ''}
                                </Button>
                                <Button
                                    variant="outlined"
                                    size="small"
                                    color="secondary"
                                    startIcon={<PictureAsPdfIcon />}
                                    onClick={handleExportAllPDFs}
                                >
                                    PDFs {processedReports.reportsByCuadrilla.length > 1 ? '(Separados)' : ''}
                                </Button>
                                {processedReports.reportsByCuadrilla.length > 1 && (
                                    <Button
                                        variant="contained"
                                        size="small"
                                        color="secondary"
                                        startIcon={downloadingZip ? <CircularProgress size={16} color="inherit" /> : <FolderZipIcon />}
                                        onClick={handleExportZip}
                                        disabled={downloadingZip}
                                    >
                                        {downloadingZip ? 'Generando ZIP...' : 'Descargar ZIP'}
                                    </Button>
                                )}
                                <Button
                                    variant="contained"
                                    size="small"
                                    color="success"
                                    startIcon={<WhatsAppIcon />}
                                    onClick={handleOpenWhatsappModal}
                                    sx={{ backgroundColor: '#25D366', '&:hover': { backgroundColor: '#1ebe57' } }}
                                >
                                    Enviar por WhatsApp
                                </Button>
                            </Stack>
                        </Box>

                        <Divider sx={{ my: 1.5 }} />

                        {/* Totales clave consolidados en cuadrícula */}
                        <Box sx={{
                            display: 'grid',
                            gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', md: '1fr 1fr 1fr 1fr' },
                            gap: 2,
                            mt: 2
                        }}>
                            <Paper variant="outlined" sx={{ p: 1.5, backgroundColor: '#ffffff', borderRadius: 1.5 }}>
                                <Typography variant="caption" color="text.secondary">Producción (con IVA)</Typography>
                                <Typography variant="h6" fontWeight={700} color="primary.main">
                                    {fmt(processedReports.globalTotales.totalConIva)}
                                </Typography>
                                <Typography variant="caption" color="text.disabled">
                                    Sin IVA: {fmt(processedReports.globalTotales.totalSinIva)}
                                </Typography>
                            </Paper>

                            <Paper variant="outlined" sx={{ p: 1.5, backgroundColor: '#ffffff', borderRadius: 1.5 }}>
                                <Typography variant="caption" color="text.secondary">(-) Adelantos & Combustible</Typography>
                                <Typography variant="h6" fontWeight={700} color="error.main">
                                    {fmt(processedReports.globalTotales.totalAdelantos + processedReports.globalTotales.totalCombustible)}
                                </Typography>
                                <Typography variant="caption" color="text.disabled">
                                    Adel: {fmt(processedReports.globalTotales.totalAdelantos)} | Comb: {fmt(processedReports.globalTotales.totalCombustible)}
                                </Typography>
                            </Paper>

                            <Paper variant="outlined" sx={{ p: 1.5, backgroundColor: '#ffffff', borderRadius: 1.5 }}>
                                <Typography variant="caption" color="text.secondary">(-) Garantías / Desc. / Herr.</Typography>
                                <Typography variant="h6" fontWeight={700} color="error.dark">
                                    {fmt(processedReports.globalTotales.totalGarantias + processedReports.globalTotales.totalDescuentos + processedReports.globalTotales.totalHerramientas - processedReports.globalTotales.totalBonificaciones)}
                                </Typography>
                                <Typography variant="caption" color="text.disabled">
                                    Bonif: +{fmt(processedReports.globalTotales.totalBonificaciones)}
                                </Typography>
                            </Paper>

                            <Paper variant="outlined" sx={{ p: 1.5, backgroundColor: processedReports.globalTotales.neto >= 0 ? '#e8f5e9' : '#ffebee', borderRadius: 1.5, borderColor: processedReports.globalTotales.neto >= 0 ? '#a5d6a7' : '#ef9a9a' }}>
                                <Typography variant="caption" fontWeight={700} color={processedReports.globalTotales.neto >= 0 ? 'success.dark' : 'error.dark'}>
                                    TOTAL NETO A PAGAR
                                </Typography>
                                <Typography variant="h6" fontWeight={800} color={processedReports.globalTotales.neto >= 0 ? 'success.main' : 'error.main'}>
                                    {fmt(processedReports.globalTotales.neto)}
                                </Typography>
                                <Typography variant="caption" fontWeight={600} color="text.secondary">
                                    A facturar: {fmt(processedReports.globalTotales.totalFacturar)}
                                </Typography>
                            </Paper>
                        </Box>
                    </Paper>

                    {/* Acciones de Acordeones */}
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, px: 0.5 }}>
                        <Typography variant="subtitle1" fontWeight={700}>
                            Informes de Producción por Cuadrilla ({processedReports.reportsByCuadrilla.length})
                        </Typography>
                        <Stack direction="row" spacing={1}>
                            <Button
                                size="small"
                                variant="text"
                                startIcon={<UnfoldMoreIcon />}
                                onClick={handleExpandAll}
                            >
                                Expandir Todos
                            </Button>
                            <Button
                                size="small"
                                variant="text"
                                startIcon={<UnfoldLessIcon />}
                                onClick={handleCollapseAll}
                            >
                                Colapsar Todos
                            </Button>
                        </Stack>
                    </Box>

                    {/* Lista de Acordeones por Cuadrilla */}
                    {processedReports.reportsByCuadrilla.map((rep) => {
                        const { cuadrilla, data, totales, pct } = rep;
                        const isExpanded = !!expandedAccordions[cuadrilla.id];

                        return (
                            <Accordion
                                key={cuadrilla.id}
                                expanded={isExpanded}
                                onChange={() => toggleAccordion(cuadrilla.id)}
                                elevation={2}
                                sx={{
                                    mb: 2,
                                    borderRadius: '8px !important',
                                    border: '1px solid #e0e0e0',
                                    '&:before': { display: 'none' },
                                    overflow: 'hidden'
                                }}
                            >
                                {/* Cabecera del Acordeón (Card Resumen Compacta) */}
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    sx={{
                                        backgroundColor: isExpanded ? '#f0f7ff' : '#fafafa',
                                        borderBottom: isExpanded ? '1px solid #d0e2ff' : 'none',
                                        py: 1,
                                        px: 2.5
                                    }}
                                >
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', pr: 2, flexWrap: 'wrap', gap: 1.5 }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                            <Typography variant="subtitle1" fontWeight={700}>
                                                {cuadrilla.numero}
                                            </Typography>
                                            {cuadrilla.usuario && (
                                                <Typography variant="body2" color="text.secondary">
                                                    ({cuadrilla.usuario})
                                                </Typography>
                                            )}
                                            <Chip
                                                label={`${data.ordenes.filter(o => !!checkOverrides[o.id]).length}/${data.ordenes.length} prod.`}
                                                size="small"
                                                color="success"
                                                variant="outlined"
                                            />
                                            {data.ordenes.filter(o => !checkOverrides[o.id]).length > 0 && (
                                                <Chip
                                                    label={`${data.ordenes.filter(o => !checkOverrides[o.id]).length} anul.`}
                                                    size="small"
                                                    color="error"
                                                    variant="outlined"
                                                />
                                            )}
                                        </Box>

                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                            <Box sx={{ textAlign: 'right' }}>
                                                <Typography variant="caption" color="text.secondary" display="block">
                                                    Neto a Pagar
                                                </Typography>
                                                <Typography
                                                    variant="subtitle1"
                                                    fontWeight={800}
                                                    color={totales.neto >= 0 ? 'success.main' : 'error.main'}
                                                >
                                                    {fmt(totales.neto)}
                                                </Typography>
                                            </Box>

                                            {/* Botones individuales de descarga sin activar el acordeón */}
                                            <Box onClick={(e) => e.stopPropagation()} sx={{ display: 'flex', gap: 0.5 }}>
                                                <Tooltip title="Descargar Excel de esta cuadrilla">
                                                    <IconButton
                                                        size="small"
                                                        color="primary"
                                                        onClick={() => handleExportExcel(cuadrilla.id)}
                                                    >
                                                        <FileDownloadIcon fontSize="small" />
                                                    </IconButton>
                                                </Tooltip>
                                                <Tooltip title="Descargar PDF de esta cuadrilla">
                                                    <IconButton
                                                        size="small"
                                                        color="secondary"
                                                        onClick={() => handleExportSinglePDF(cuadrilla.id)}
                                                    >
                                                        <PictureAsPdfIcon fontSize="small" />
                                                    </IconButton>
                                                </Tooltip>
                                                <Tooltip title={`Enviar liquidación por WhatsApp (${cuadrilla.nroTelefono || 'Configurar teléfono'})`}>
                                                    <IconButton
                                                        size="small"
                                                        sx={{ color: '#25D366' }}
                                                        onClick={() => {
                                                            if (cuadrilla.nroTelefono || whatsappPhones[cuadrilla.id]) {
                                                                handleSendSingleWhatsapp(rep);
                                                            } else {
                                                                handleOpenWhatsappModal();
                                                            }
                                                        }}
                                                    >
                                                        <WhatsAppIcon fontSize="small" />
                                                    </IconButton>
                                                </Tooltip>
                                            </Box>
                                        </Box>
                                    </Box>
                                </AccordionSummary>

                                {/* Contenido Detallado del Acordeón */}
                                <AccordionDetails sx={{ p: 3, backgroundColor: '#ffffff' }}>
                                    {/* Resumen rápido de la cuadrilla */}
                                    <Paper elevation={1} sx={{ p: 2.5, mb: 3, borderLeft: '5px solid #1976d2', backgroundColor: '#fafcff' }}>
                                        <Typography variant="subtitle1" fontWeight={700} mb={1}>
                                            Resumen — {cuadrilla.numero}
                                        </Typography>
                                        <SummaryRow label="Producción sin IVA" value={fmt(totales.totalSinIva)} />
                                        <SummaryRow label="Producción con IVA (10%)" value={fmt(totales.totalConIva)} />
                                        <SummaryRow label="(+) Total Bonificaciones" value={`+ ${fmt(totales.totalBonificaciones)}`} color="success.main" />
                                        <SummaryRow label="(-) Total Adelantos" value={fmt(totales.totalAdelantos)} color="error.main" />
                                        <SummaryRow label="(-) Total Combustible" value={fmt(totales.totalCombustible)} color="error.main" />
                                        <SummaryRow label="(-) Total Garantías" value={fmt(totales.totalGarantias)} color="error.main" />
                                        <SummaryRow label="(-) Total Descuentos" value={fmt(totales.totalDescuentos)} color="error.main" />
                                        <SummaryRow label="(-) Total Herramientas (Entregas/Devoluciones)" value={fmt(totales.totalHerramientas)} color="error.main" />
                                        <Divider sx={{ my: 1 }} />
                                        <SummaryRow
                                            label="NETO A PAGAR"
                                            value={fmt(totales.neto)}
                                            color={totales.neto >= 0 ? 'success.main' : 'error.main'}
                                            bold
                                            size="h6"
                                        />
                                        <SummaryRow
                                            label="Total a facturar"
                                            value={fmt(totales.totalFacturar)}
                                            bold
                                            size="h6"
                                        />
                                    </Paper>

                                    {/* Sección Órdenes de Trabajo */}
                                    <Paper elevation={1} sx={{ p: 2.5, mb: 3 }}>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5, flexWrap: 'wrap', gap: 1 }}>
                                            <SectionTitle color="#1565c0">Órdenes de Trabajo</SectionTitle>
                                            <Box sx={{ display: 'flex', gap: 1 }}>
                                                <Chip label={`${data.ordenes.filter(o => !!checkOverrides[o.id]).length} Producidas`} size="small" color="primary" variant="outlined" />
                                                {data.ordenes.filter(o => !checkOverrides[o.id]).length > 0 && (
                                                    <Chip label={`${data.ordenes.filter(o => !checkOverrides[o.id]).length} Anuladas (Valor ₲ 0)`} size="small" color="error" variant="outlined" />
                                                )}
                                            </Box>
                                        </Box>
                                        {data.ordenes.length === 0 ? (
                                            <Typography color="text.secondary" sx={{ py: 2, textAlign: 'center' }}>Sin órdenes en el período</Typography>
                                        ) : (
                                            <TableContainer>
                                                <Table size="small">
                                                    <TableHead>
                                                        <TableRow sx={{ backgroundColor: '#e3f2fd' }}>
                                                            <TableCell><strong>Formulario</strong></TableCell>
                                                            <TableCell><strong>Contrato</strong></TableCell>
                                                            <TableCell><strong>OT</strong></TableCell>
                                                            <TableCell><strong>Cliente</strong></TableCell>
                                                            <TableCell><strong>Fecha</strong></TableCell>
                                                            <TableCell align="center">
                                                                <Tooltip title="Tilde: Producida (incluida en total). Destilde: Anulada (valor 0 con motivo).">
                                                                    <strong>Estado</strong>
                                                                </Tooltip>
                                                            </TableCell>
                                                            <TableCell align="right"><strong>Subtotal</strong></TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {data.ordenes.map((o) => {
                                                            const isChecked = !!checkOverrides[o.id];
                                                            const originalSubtotal = calculateOrderPayout(o, pct);
                                                            const subtotal = isChecked ? originalSubtotal : 0;
                                                            const motivo = !isChecked ? (motivosOverrides[o.id] || o.motivoAnulacion || 'No descargó materiales') : '';

                                                            return (
                                                                <TableRow
                                                                    key={o.id}
                                                                    hover
                                                                    sx={{
                                                                        opacity: isChecked ? 1 : 0.65,
                                                                        backgroundColor: isChecked ? 'inherit' : '#fff5f5'
                                                                    }}
                                                                >
                                                                    <TableCell>{o.nroFormulario || ''}</TableCell>
                                                                    <TableCell>{o.contrato || ''}</TableCell>
                                                                    <TableCell>{o.nroOt || ''}</TableCell>
                                                                    <TableCell>
                                                                        <Box>
                                                                            <Typography variant="body2" sx={{ textDecoration: isChecked ? 'none' : 'line-through', color: isChecked ? 'inherit' : 'text.secondary' }}>
                                                                                {o.cliente || ''}
                                                                            </Typography>
                                                                            {!isChecked && (
                                                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.5 }}>
                                                                                    <Chip
                                                                                        size="small"
                                                                                        icon={<BlockIcon style={{ fontSize: 13 }} />}
                                                                                        label={`Anulada: ${motivo}`}
                                                                                        color="error"
                                                                                        variant="outlined"
                                                                                        sx={{ height: 20, fontSize: '0.72rem' }}
                                                                                    />
                                                                                    {isAdmin && (
                                                                                        <Tooltip title="Editar motivo de anulación">
                                                                                            <IconButton size="small" onClick={() => handleEditMotivo(o)} sx={{ p: 0.2 }}>
                                                                                                <EditIcon style={{ fontSize: 14 }} color="action" />
                                                                                            </IconButton>
                                                                                        </Tooltip>
                                                                                    )}
                                                                                </Box>
                                                                            )}
                                                                        </Box>
                                                                    </TableCell>
                                                                    <TableCell>{moment(o.date, "YYYYMMDD").format("DD/MM/YYYY")}</TableCell>
                                                                    <TableCell align="center">
                                                                        <Tooltip title={isAdmin ? (isChecked ? 'Orden producida — click para anular con motivo' : 'Orden anulada — click para reactivar') : (isChecked ? 'Producida' : 'Anulada')}>
                                                                            <span>
                                                                                <Checkbox
                                                                                    checked={isChecked}
                                                                                    onChange={isAdmin ? () => handleClickCheckbox(o) : undefined}
                                                                                    disabled={!isAdmin}
                                                                                    color="primary"
                                                                                    size="small"
                                                                                />
                                                                            </span>
                                                                        </Tooltip>
                                                                    </TableCell>
                                                                    <TableCell align="right">
                                                                        {isChecked ? (
                                                                            <Typography variant="body2" fontWeight={600}>
                                                                                {fmt(subtotal)}
                                                                            </Typography>
                                                                        ) : (
                                                                            <Box>
                                                                                <Typography variant="body2" color="error.main" fontWeight={700}>
                                                                                    ₲ 0
                                                                                </Typography>
                                                                                <Typography variant="caption" color="text.disabled" sx={{ textDecoration: 'line-through', display: 'block' }}>
                                                                                    {fmt(originalSubtotal)}
                                                                                </Typography>
                                                                            </Box>
                                                                        )}
                                                                    </TableCell>
                                                                </TableRow>
                                                            );
                                                        })}
                                                        <TableRow sx={{ backgroundColor: '#f0f7ff' }}>
                                                            <TableCell colSpan={6} align="right"><strong>Total Sin IVA</strong></TableCell>
                                                            <TableCell align="right"><strong>{fmt(totales.totalSinIva)}</strong></TableCell>
                                                        </TableRow>
                                                        <TableRow sx={{ backgroundColor: '#e3f2fd' }}>
                                                            <TableCell colSpan={6} align="right"><strong>Total Con IVA (10%)</strong></TableCell>
                                                            <TableCell align="right"><strong>{fmt(totales.totalConIva)}</strong></TableCell>
                                                        </TableRow>
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        )}
                                    </Paper>

                                    {/* Sección Adelantos */}
                                    <Paper elevation={1} sx={{ p: 2.5, mb: 3 }}>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
                                            <SectionTitle color="#c62828">Adelantos</SectionTitle>
                                            <Chip label={`${data.adelantos.length} registros`} size="small" color="error" variant="outlined" />
                                        </Box>
                                        {data.adelantos.length === 0 ? (
                                            <Typography color="text.secondary" sx={{ py: 2, textAlign: 'center' }}>Sin adelantos en el período</Typography>
                                        ) : (
                                            <TableContainer>
                                                <Table size="small">
                                                    <TableHead>
                                                        <TableRow sx={{ backgroundColor: '#ffebee' }}>
                                                            <TableCell><strong>Fecha</strong></TableCell>
                                                            <TableCell align="right"><strong>Monto</strong></TableCell>
                                                            <TableCell><strong>Observaciones</strong></TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {data.adelantos.map((a) => (
                                                            <TableRow key={a.id} hover>
                                                                <TableCell>{a.fechaDisplay || a.fecha}</TableCell>
                                                                <TableCell align="right" sx={{ color: 'error.main' }}>{fmt(a.monto)}</TableCell>
                                                                <TableCell>{a.observaciones || ''}</TableCell>
                                                            </TableRow>
                                                        ))}
                                                        <TableRow sx={{ backgroundColor: '#ffebee' }}>
                                                            <TableCell align="right"><strong>Total Adelantos</strong></TableCell>
                                                            <TableCell align="right" sx={{ color: 'error.main' }}><strong>{fmt(totales.totalAdelantos)}</strong></TableCell>
                                                            <TableCell />
                                                        </TableRow>
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        )}
                                    </Paper>

                                    {/* Sección Combustible */}
                                    <Paper elevation={1} sx={{ p: 2.5, mb: 3 }}>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
                                            <SectionTitle color="#e65100">Combustible</SectionTitle>
                                            <Chip label={`${data.combustible.length} registros`} size="small" color="warning" variant="outlined" />
                                        </Box>
                                        {data.combustible.length === 0 ? (
                                            <Typography color="text.secondary" sx={{ py: 2, textAlign: 'center' }}>Sin registros de combustible en el período</Typography>
                                        ) : (
                                            <TableContainer>
                                                <Table size="small">
                                                    <TableHead>
                                                        <TableRow sx={{ backgroundColor: '#fff3e0' }}>
                                                            <TableCell><strong>Fecha</strong></TableCell>
                                                            <TableCell><strong>Patente</strong></TableCell>
                                                            <TableCell><strong>Producto</strong></TableCell>
                                                            <TableCell align="right"><strong>Cant.</strong></TableCell>
                                                            <TableCell align="right"><strong>Precio Unit.</strong></TableCell>
                                                            <TableCell align="right"><strong>Total</strong></TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {data.combustible.map((c) => (
                                                            <TableRow key={c.id} hover>
                                                                <TableCell>{c.fechaDisplay || c.fecha}</TableCell>
                                                                <TableCell>{c.patente}</TableCell>
                                                                <TableCell>{c.producto}</TableCell>
                                                                <TableCell align="right">{c.cantidad}</TableCell>
                                                                <TableCell align="right">{fmt(c.precioUnitario)}</TableCell>
                                                                <TableCell align="right" sx={{ color: 'warning.dark' }}>{fmt(c.total)}</TableCell>
                                                            </TableRow>
                                                        ))}
                                                        <TableRow sx={{ backgroundColor: '#fff3e0' }}>
                                                            <TableCell colSpan={5} align="right"><strong>Total Combustible</strong></TableCell>
                                                            <TableCell align="right" sx={{ color: 'warning.dark' }}><strong>{fmt(totales.totalCombustible)}</strong></TableCell>
                                                        </TableRow>
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        )}
                                    </Paper>

                                    {/* Sección Garantías */}
                                    <Paper elevation={1} sx={{ p: 2.5, mb: 3 }}>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
                                            <SectionTitle color="#4a148c">Garantías a Descontar</SectionTitle>
                                            <Chip label={`${(data.garantias || []).length} registros`} size="small" color="secondary" variant="outlined" />
                                        </Box>
                                        {(!data.garantias || data.garantias.length === 0) ? (
                                            <Typography color="text.secondary" sx={{ py: 2, textAlign: 'center' }}>Sin garantías a descontar en el período</Typography>
                                        ) : (
                                            <TableContainer>
                                                <Table size="small">
                                                    <TableHead>
                                                        <TableRow sx={{ backgroundColor: '#f3e5f5' }}>
                                                            <TableCell><strong>Contrato</strong></TableCell>
                                                            <TableCell><strong>Nro OT</strong></TableCell>
                                                            <TableCell><strong>Cliente</strong></TableCell>
                                                            <TableCell><strong>Fecha</strong></TableCell>
                                                            {isAdmin && <TableCell align="right"><strong>Monto Original</strong></TableCell>}
                                                            <TableCell align="right"><strong>Descuento</strong></TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {data.garantias.map((g) => {
                                                            const gData = g[0] || g["0"] || g;
                                                            const total = calculateOrderTotal(gData);
                                                            const descuentoGarantia = calculateOrderPayout(gData, pct);
                                                            return (
                                                                <TableRow key={g.id} hover>
                                                                    <TableCell>{gData?.contrato || 'N/A'}</TableCell>
                                                                    <TableCell>{gData?.nroOt || 'N/A'}</TableCell>
                                                                    <TableCell>{gData?.cliente || 'N/A'}</TableCell>
                                                                    <TableCell>{moment(gData?.date, "YYYYMMDD").format("DD/MM/YYYY")}</TableCell>
                                                                    {isAdmin && <TableCell align="right">{fmt(total)}</TableCell>}
                                                                    <TableCell align="right" sx={{ color: 'error.main' }}>{fmt(descuentoGarantia)}</TableCell>
                                                                </TableRow>
                                                            );
                                                        })}
                                                        <TableRow sx={{ backgroundColor: '#f3e5f5' }}>
                                                            <TableCell colSpan={isAdmin ? 5 : 4} align="right"><strong>Total Garantías</strong></TableCell>
                                                            <TableCell align="right" sx={{ color: 'error.main' }}><strong>{fmt(totales.totalGarantias)}</strong></TableCell>
                                                        </TableRow>
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        )}
                                    </Paper>

                                    {/* Sección Descuentos / Bonificaciones */}
                                    <Paper elevation={1} sx={{ p: 2.5, mb: 3 }}>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
                                            <SectionTitle color="#6a1b9a">Descuentos / Bonificaciones</SectionTitle>
                                            <Chip label={`${data.descuentos?.length || 0} registros`} size="small" color="secondary" variant="outlined" />
                                        </Box>
                                        {!data.descuentos || data.descuentos.length === 0 ? (
                                            <Typography color="text.secondary" sx={{ py: 2, textAlign: 'center' }}>Sin registros en el período</Typography>
                                        ) : (
                                            <TableContainer>
                                                <Table size="small">
                                                    <TableHead>
                                                        <TableRow sx={{ backgroundColor: '#f3e5f5' }}>
                                                            <TableCell><strong>Fecha</strong></TableCell>
                                                            <TableCell><strong>Tipo</strong></TableCell>
                                                            <TableCell align="right"><strong>Monto</strong></TableCell>
                                                            <TableCell><strong>Observaciones</strong></TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {data.descuentos.map((d) => {
                                                            const isBonif = String(d.tipo || '').toUpperCase().includes('BONIFICACION');
                                                            return (
                                                                <TableRow key={d.id} hover>
                                                                    <TableCell>{d.fechaDisplay || d.fecha}</TableCell>
                                                                    <TableCell>{d.tipo}</TableCell>
                                                                    <TableCell align="right" sx={{ color: isBonif ? 'success.main' : 'secondary.main', fontWeight: 'bold' }}>
                                                                        {isBonif ? `+ ${fmt(d.monto)}` : fmt(d.monto)}
                                                                    </TableCell>
                                                                    <TableCell>{d.observaciones || ''}</TableCell>
                                                                </TableRow>
                                                            );
                                                        })}
                                                        <TableRow sx={{ backgroundColor: '#f3e5f5' }}>
                                                            <TableCell colSpan={2} align="right">
                                                                <strong>Desc: {fmt(totales.totalDescuentos)} | Bonif: +{fmt(totales.totalBonificaciones)}</strong>
                                                            </TableCell>
                                                            <TableCell align="right" sx={{ color: 'secondary.main' }}>
                                                                <strong>{fmt(totales.totalBonificaciones - totales.totalDescuentos)}</strong>
                                                            </TableCell>
                                                            <TableCell />
                                                        </TableRow>
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        )}
                                    </Paper>

                                    {/* Sección Herramientas */}
                                    <Paper elevation={1} sx={{ p: 2.5, mb: 3 }}>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
                                            <SectionTitle color="#d32f2f">Herramientas (Entregas / Devoluciones)</SectionTitle>
                                            <Chip label={`${data.herramientasStock?.length || 0} movimientos`} size="small" color="error" variant="outlined" />
                                        </Box>
                                        {!data.herramientasStock || data.herramientasStock.length === 0 ? (
                                            <Typography color="text.secondary" sx={{ py: 2, textAlign: 'center' }}>Sin movimientos de herramientas en el período</Typography>
                                        ) : (
                                            <TableContainer>
                                                <Table size="small">
                                                    <TableHead>
                                                        <TableRow sx={{ backgroundColor: '#ffebee' }}>
                                                            <TableCell><strong>Fecha</strong></TableCell>
                                                            <TableCell><strong>Movimiento</strong></TableCell>
                                                            <TableCell><strong>Herramienta</strong></TableCell>
                                                            <TableCell align="right"><strong>Cantidad</strong></TableCell>
                                                            <TableCell align="right"><strong>Precio Unitario</strong></TableCell>
                                                            <TableCell align="right"><strong>Subtotal</strong></TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {data.herramientasStock.map((h) => {
                                                            const subtotal = h.cantidad * (h.herramientaPrecio || h.precio || 0);
                                                            return (
                                                                <TableRow key={h.id} hover>
                                                                    <TableCell>{h.fechaDisplay || h.fecha}</TableCell>
                                                                    <TableCell>
                                                                        <Chip
                                                                            label={h.tipo === 'salida' ? 'Entrega' : 'Devolución'}
                                                                            size="small"
                                                                            sx={{ bgcolor: h.tipo === 'salida' ? '#e57373' : '#81c784', color: 'white', fontWeight: 'bold' }}
                                                                        />
                                                                    </TableCell>
                                                                    <TableCell>{h.herramientaNombre || h.nombre}</TableCell>
                                                                    <TableCell align="right">{h.cantidad}</TableCell>
                                                                    <TableCell align="right">{fmt(h.herramientaPrecio || h.precio)}</TableCell>
                                                                    <TableCell align="right" sx={{ color: h.tipo === 'salida' ? 'error.main' : 'success.main', fontWeight: 'bold' }}>
                                                                        {h.tipo === 'salida' ? '' : '-'}{fmt(subtotal)}
                                                                    </TableCell>
                                                                </TableRow>
                                                            );
                                                        })}
                                                        <TableRow sx={{ backgroundColor: '#ffebee' }}>
                                                            <TableCell colSpan={5} align="right"><strong>Total Deducción Herramientas</strong></TableCell>
                                                            <TableCell align="right" sx={{ color: 'error.main' }}><strong>{fmt(totales.totalHerramientas)}</strong></TableCell>
                                                        </TableRow>
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        )}
                                    </Paper>

                                    {/* Resumen final individual de cuadrilla */}
                                    <Paper elevation={3} sx={{ p: 3, border: '2px solid #1976d2', borderRadius: 2, backgroundColor: '#fafcff' }}>
                                        <Typography variant="h6" fontWeight={700} mb={2} align="center">
                                            Resumen Final — {cuadrilla.numero}
                                        </Typography>
                                        <Box sx={{ maxWidth: 440, mx: 'auto' }}>
                                            <SummaryRow label="Producción (con IVA 10%)" value={fmt(totales.totalConIva)} />
                                            <SummaryRow label="(+) Total Bonificaciones" value={`+ ${fmt(totales.totalBonificaciones)}`} color="success.main" />
                                            <SummaryRow label="(-) Total Adelantos" value={`- ${fmt(totales.totalAdelantos)}`} color="error.main" />
                                            <SummaryRow label="(-) Total Combustible" value={`- ${fmt(totales.totalCombustible)}`} color="error.main" />
                                            <SummaryRow label="(-) Total Garantías" value={`- ${fmt(totales.totalGarantias)}`} color="error.main" />
                                            <SummaryRow label="(-) Total Descuentos" value={`- ${fmt(totales.totalDescuentos)}`} color="error.main" />
                                            <SummaryRow label="(-) Total Herramientas" value={`- ${fmt(totales.totalHerramientas)}`} color="error.main" />
                                            <Divider sx={{ my: 1.5 }} />
                                            <Box sx={{
                                                display: 'flex', justifyContent: 'space-between', py: 1.5, px: 2,
                                                backgroundColor: totales.neto >= 0 ? '#e8f5e9' : '#ffebee',
                                                borderRadius: 1
                                            }}>
                                                <Typography variant="h6" fontWeight={700} color={totales.neto >= 0 ? 'success.main' : 'error.main'}>
                                                    NETO A PAGAR
                                                </Typography>
                                                <Typography variant="h6" fontWeight={700} color={totales.neto >= 0 ? 'success.main' : 'error.main'}>
                                                    {fmt(totales.neto)}
                                                </Typography>
                                            </Box>
                                            <Box sx={{
                                                display: 'flex', justifyContent: 'space-between', py: 1.5, px: 2,
                                                mt: 1.5,
                                                backgroundColor: '#e3f2fd',
                                                borderRadius: 1
                                            }}>
                                                <Typography variant="h6" fontWeight={700} color="primary.main">
                                                    Total a facturar
                                                </Typography>
                                                <Typography variant="h6" fontWeight={700} color="primary.main">
                                                    {fmt(totales.totalFacturar)}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Paper>
                                </AccordionDetails>
                            </Accordion>
                        );
                    })}
                </Box>
            )}

            {/* Diálogo para ingresar Motivo de Anulación */}
            <Dialog
                open={dialogAnulacion.open}
                onClose={() => setDialogAnulacion({ open: false, orden: null, motivo: '' })}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle sx={{ fontWeight: 700, color: 'error.main' }}>
                    Anular Orden de la Producción
                </DialogTitle>
                <DialogContent>
                    <DialogContentText sx={{ mb: 2 }}>
                        Al anular esta orden, su valor pasará a <strong>₲ 0</strong> en el cálculo de producción, apareciendo tachada tanto en pantalla como en los reportes de Excel y PDF con el motivo indicado.
                    </DialogContentText>

                    {dialogAnulacion.orden && (
                        <Paper variant="outlined" sx={{ p: 1.5, mb: 2.5, backgroundColor: '#fdf7f7' }}>
                            <Typography variant="body2"><strong>OT / WO:</strong> {dialogAnulacion.orden.nroOt || dialogAnulacion.orden.workOrder || 'S/N'}</Typography>
                            <Typography variant="body2"><strong>Cliente:</strong> {dialogAnulacion.orden.cliente || 'S/D'}</Typography>
                            <Typography variant="body2"><strong>Contrato:</strong> {dialogAnulacion.orden.contrato || 'S/D'}</Typography>
                        </Paper>
                    )}

                    <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
                        Motivos rápidos frecuentes:
                    </Typography>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2 }}>
                        {QUICK_MOTIVOS.map((qm) => (
                            <Chip
                                key={qm}
                                label={qm}
                                size="small"
                                clickable
                                color={dialogAnulacion.motivo === qm ? 'error' : 'default'}
                                onClick={() => setDialogAnulacion(prev => ({ ...prev, motivo: qm }))}
                            />
                        ))}
                    </Box>

                    <TextField
                        autoFocus
                        margin="dense"
                        label="Motivo de Anulación / Observación"
                        fullWidth
                        variant="outlined"
                        multiline
                        rows={2}
                        value={dialogAnulacion.motivo}
                        onChange={(e) => setDialogAnulacion(prev => ({ ...prev, motivo: e.target.value }))}
                        placeholder="Escriba el motivo detallado de la anulación..."
                    />
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 2 }}>
                    <Button onClick={() => setDialogAnulacion({ open: false, orden: null, motivo: '' })}>
                        Cancelar
                    </Button>
                    <Button
                        variant="contained"
                        color="error"
                        onClick={handleConfirmAnulacion}
                    >
                        Confirmar Anulación
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Modal para enviar liquidaciones mensuales por WhatsApp */}
            <Dialog
                open={openWhatsappModal}
                onClose={() => setOpenWhatsappModal(false)}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1, pb: 1 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <WhatsAppIcon sx={{ color: '#25D366', fontSize: 28 }} />
                        <Box>
                            <Typography variant="h6" fontWeight={700}>
                                Enviar Liquidación Mensual por WhatsApp
                            </Typography>
                            {state.dateFrom && state.dateTo && (
                                <Typography variant="caption" color="text.secondary">
                                    Período: {moment(state.dateFrom).format("DD/MM/YYYY")} — {moment(state.dateTo).format("DD/MM/YYYY")}
                                </Typography>
                            )}
                        </Box>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Checkbox
                            size="small"
                            color="success"
                            checked={autoDownloadPdfOnSend}
                            onChange={(e) => setAutoDownloadPdfOnSend(e.target.checked)}
                        />
                        <Typography variant="body2" color="text.secondary">
                            Descargar PDF automáticamente al enviar
                        </Typography>
                    </Box>
                </DialogTitle>

                <DialogContent dividers>
                    {/* Panel de Estado del Servidor Bot Automático (Render) + Modo Enlace */}
                    <Paper
                        variant="outlined"
                        sx={{
                            p: 1.5,
                            mb: 2,
                            backgroundColor: isBotActive ? '#e8f5e9' : '#f8f9fa',
                            borderColor: isBotActive ? '#66bb6a' : '#e0e0e0'
                        }}
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Chip
                                    size="small"
                                    color={isBotActive ? 'success' : (whatsappBotState.status === 'qr_ready' ? 'warning' : 'default')}
                                    icon={isBotActive ? <CheckCircleIcon /> : <QrCode2Icon />}
                                    label={
                                        isBotActive
                                            ? `Bot Automático Conectado (${whatsappBotState.connectedName || whatsappBotState.connectedPhone || 'Activo'})`
                                            : (whatsappBotState.status === 'qr_ready'
                                                ? 'Bot listo para vincular QR'
                                                : (wakingUpBot ? 'Despertando servidor Bot...' : 'Modo Enlace PDF en la Nube Activo'))
                                    }
                                />
                                <Typography variant="caption" color="text.secondary">
                                    {isBotActive
                                        ? 'Envía el archivo .pdf adjunto 100% automático en segundo plano.'
                                        : 'Sube el PDF a Firebase Storage e incluye el link directo en el mensaje (o activá el Bot en Render).'}
                                </Typography>
                            </Box>
                            <Stack direction="row" spacing={1}>
                                {whatsappBotState.serverUrl && !isBotActive && (
                                    <Button
                                        size="small"
                                        variant="outlined"
                                        startIcon={wakingUpBot ? <CircularProgress size={14} /> : <RefreshIcon />}
                                        onClick={() => wakeUpWhatsappBotServer()}
                                        disabled={wakingUpBot}
                                    >
                                        {wakingUpBot ? 'Despertando...' : 'Despertar Bot'}
                                    </Button>
                                )}
                                <Button
                                    size="small"
                                    variant="text"
                                    startIcon={<SettingsIcon />}
                                    onClick={() => setShowBotConfig(prev => !prev)}
                                >
                                    {showBotConfig ? 'Ocultar Config Bot' : 'Configurar Bot Render'}
                                </Button>
                            </Stack>
                        </Box>

                        {showBotConfig && (
                            <Box sx={{ mt: 1.5, pt: 1.5, borderTop: '1px dashed #ccc', display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap' }}>
                                <TextField
                                    size="small"
                                    sx={{ flex: 1, minWidth: 260 }}
                                    label="URL del Servicio en Render (ej: https://personal-whatsapp-bot.onrender.com)"
                                    value={botServerUrlInput}
                                    onChange={(e) => setBotServerUrlInput(e.target.value)}
                                    placeholder="https://tu-servicio.onrender.com"
                                />
                                <Button
                                    size="small"
                                    variant="contained"
                                    onClick={handleSaveBotServerUrl}
                                >
                                    Guardar y Despertar
                                </Button>
                            </Box>
                        )}

                        {whatsappBotState.status === 'qr_ready' && whatsappBotState.qrDataUrl && !isBotActive && (
                            <Box sx={{ mt: 2, p: 2, textAlign: 'center', backgroundColor: '#fff', borderRadius: 1, border: '1px solid #ffe082' }}>
                                <Typography variant="subtitle2" fontWeight={700} gutterBottom>
                                    Escaneá este código QR desde el WhatsApp de Administración (Dispositivos vinculados → Vincular un dispositivo)
                                </Typography>
                                <Box
                                    component="img"
                                    src={whatsappBotState.qrDataUrl}
                                    alt="WhatsApp QR"
                                    sx={{ width: 220, height: 220, mx: 'auto', display: 'block', my: 1 }}
                                />
                                <Typography variant="caption" color="text.secondary">
                                    La sesión queda respaldada automáticamente en Firestore aunque el servidor de Render entre en reposo.
                                </Typography>
                            </Box>
                        )}
                    </Paper>

                    {/* Cola de envío masivo secuencial (con todos los PDFs ya subidos a la nube) */}
                    {bulkQueueIndex !== null && processedReports && (() => {
                        const validQueue = processedReports.reportsByCuadrilla.filter(({ cuadrilla }) => {
                            const raw = whatsappPhones[cuadrilla.id] !== undefined
                                ? whatsappPhones[cuadrilla.id]
                                : (cuadrilla.nroTelefono || cuadrilla.telefono || '');
                            return formatPhoneForWhatsapp(raw).length >= 8;
                        });
                        const nextRep = validQueue[bulkQueueIndex];
                        if (!nextRep) return null;
                        return (
                            <Paper
                                variant="outlined"
                                sx={{
                                    p: 2,
                                    mb: 2,
                                    backgroundColor: '#e8f5e9',
                                    borderColor: '#66bb6a',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    flexWrap: 'wrap',
                                    gap: 1.5
                                }}
                            >
                                <Box>
                                    <Typography variant="subtitle2" fontWeight={700} color="success.dark">
                                        Envío Masivo en Curso ({bulkQueueIndex} de {validQueue.length} abiertos — PDFs ya subidos a la nube)
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        Siguiente cuadrilla: <strong>{nextRep.cuadrilla.numero}</strong> ({whatsappPhones[nextRep.cuadrilla.id] || nextRep.cuadrilla.nroTelefono})
                                    </Typography>
                                </Box>
                                <Stack direction="row" spacing={1}>
                                    <Button
                                        size="small"
                                        variant="outlined"
                                        color="inherit"
                                        onClick={() => setBulkQueueIndex(null)}
                                    >
                                        Detener cola
                                    </Button>
                                    <Button
                                        size="small"
                                        variant="contained"
                                        startIcon={<WhatsAppIcon />}
                                        sx={{ backgroundColor: '#25D366', '&:hover': { backgroundColor: '#1ebe57' } }}
                                        onClick={() => {
                                            handleSendSingleWhatsapp(nextRep, whatsappPdfUrls[nextRep.cuadrilla.id] || '');
                                            if (bulkQueueIndex + 1 < validQueue.length) {
                                                setBulkQueueIndex(bulkQueueIndex + 1);
                                            } else {
                                                setBulkQueueIndex(null);
                                            }
                                        }}
                                    >
                                        Abrir Siguiente WhatsApp ({bulkQueueIndex + 1}/{validQueue.length})
                                    </Button>
                                </Stack>
                            </Paper>
                        );
                    })()}

                    <TableContainer component={Paper} variant="outlined" sx={{ maxHeight: 440 }}>
                        <Table size="small" stickyHeader>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 700, backgroundColor: '#f5f5f5' }}>Cuadrilla</TableCell>
                                    <TableCell align="right" sx={{ fontWeight: 700, backgroundColor: '#f5f5f5' }}>Neto a Pagar</TableCell>
                                    <TableCell sx={{ fontWeight: 700, backgroundColor: '#f5f5f5', minWidth: 220 }}>Teléfono (Editable)</TableCell>
                                    <TableCell align="center" sx={{ fontWeight: 700, backgroundColor: '#f5f5f5', minWidth: 230 }}>Acciones / Estado</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {(processedReports?.reportsByCuadrilla || []).map((rep) => {
                                    const { cuadrilla, totales } = rep;
                                    const phoneVal = whatsappPhones[cuadrilla.id] !== undefined
                                        ? whatsappPhones[cuadrilla.id]
                                        : (cuadrilla.nroTelefono || cuadrilla.telefono || '');
                                    const formattedPhone = formatPhoneForWhatsapp(phoneVal);
                                    const isPhoneValid = formattedPhone.length >= 8;
                                    const wasSent = !!whatsappSentMap[cuadrilla.id];
                                    const sendState = whatsappStatusMap[cuadrilla.id]; // 'uploading' | 'queued' | 'sending' | 'ready' | 'sent' | 'error'
                                    const isBusy = sendState === 'uploading' || sendState === 'queued' || sendState === 'sending';
                                    const errorMsg = whatsappErrorMap[cuadrilla.id];
                                    const uploadedUrl = whatsappPdfUrls[cuadrilla.id];
                                    const isDirty = String(phoneVal || '').trim() !== String(cuadrilla.nroTelefono || cuadrilla.telefono || '').trim();

                                    return (
                                        <TableRow
                                            key={cuadrilla.id}
                                            hover
                                            sx={{
                                                backgroundColor: sendState === 'error'
                                                    ? '#ffebee'
                                                    : (wasSent ? '#f1f8e9' : 'inherit')
                                            }}
                                        >
                                            <TableCell>
                                                <Typography variant="body2" fontWeight={700}>
                                                    {cuadrilla.numero}
                                                </Typography>
                                                {cuadrilla.usuario && (
                                                    <Typography variant="caption" color="text.secondary">
                                                        {cuadrilla.usuario}
                                                    </Typography>
                                                )}
                                            </TableCell>

                                            <TableCell align="right">
                                                <Typography
                                                    variant="body2"
                                                    fontWeight={700}
                                                    color={totales.neto >= 0 ? 'success.main' : 'error.main'}
                                                >
                                                    {fmt(totales.neto)}
                                                </Typography>
                                                <Typography variant="caption" color="text.secondary" display="block">
                                                    Fact: {fmt(totales.totalFacturar)}
                                                </Typography>
                                            </TableCell>

                                            <TableCell>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                    <TextField
                                                        size="small"
                                                        fullWidth
                                                        placeholder="Ej: 0981123456"
                                                        value={phoneVal}
                                                        onChange={(e) => {
                                                            const val = e.target.value;
                                                            setWhatsappPhones(prev => ({
                                                                ...prev,
                                                                [cuadrilla.id]: val
                                                            }));
                                                        }}
                                                        onBlur={() => persistPhoneIfChanged(cuadrilla, phoneVal)}
                                                        error={Boolean(phoneVal) && !isPhoneValid}
                                                        helperText={
                                                            Boolean(phoneVal) && !isPhoneValid
                                                                ? 'Número inválido'
                                                                : (isPhoneValid ? `WA: +${formattedPhone}` : 'Sin número registrado')
                                                        }
                                                    />
                                                    {isDirty && (
                                                        <Tooltip title="Guardar teléfono en cuadrilla">
                                                            <IconButton
                                                                size="small"
                                                                color="primary"
                                                                disabled={savingPhoneId === cuadrilla.id}
                                                                onClick={() => persistPhoneIfChanged(cuadrilla, phoneVal)}
                                                            >
                                                                <SaveIcon fontSize="small" />
                                                            </IconButton>
                                                        </Tooltip>
                                                    )}
                                                </Box>
                                            </TableCell>

                                            <TableCell align="center">
                                                <Stack direction="row" spacing={0.5} justifyContent="center" alignItems="center">
                                                    <Tooltip title="Descargar PDF en tu PC">
                                                        <IconButton
                                                            size="small"
                                                            color="secondary"
                                                            onClick={() => handleExportSinglePDF(cuadrilla.id)}
                                                        >
                                                            <PictureAsPdfIcon fontSize="small" />
                                                        </IconButton>
                                                    </Tooltip>

                                                    {uploadedUrl && (
                                                        <Tooltip title="Abrir PDF subido en la nube">
                                                            <IconButton
                                                                size="small"
                                                                color="primary"
                                                                component="a"
                                                                href={uploadedUrl}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                <OpenInNewIcon fontSize="small" />
                                                            </IconButton>
                                                        </Tooltip>
                                                    )}

                                                    {sendState === 'error' && errorMsg && (
                                                        <Tooltip title={errorMsg}>
                                                            <ErrorOutlineIcon color="error" fontSize="small" />
                                                        </Tooltip>
                                                    )}

                                                    <Button
                                                        size="small"
                                                        variant={wasSent ? "outlined" : "contained"}
                                                        color={sendState === 'error' ? "error" : "success"}
                                                        disabled={!isPhoneValid || isBusy}
                                                        startIcon={
                                                            isBusy
                                                                ? <CircularProgress size={14} color="inherit" />
                                                                : (wasSent ? <CheckCircleIcon /> : <WhatsAppIcon />)
                                                        }
                                                        onClick={() => handleSendSingleWhatsapp(rep)}
                                                        sx={!wasSent && sendState !== 'error' ? {
                                                            backgroundColor: '#25D366',
                                                            '&:hover': { backgroundColor: '#1ebe57' },
                                                            textTransform: 'none'
                                                        } : { textTransform: 'none' }}
                                                    >
                                                        {sendState === 'uploading'
                                                            ? 'Subiendo PDF...'
                                                            : (sendState === 'queued' || sendState === 'sending'
                                                                ? 'Enviando PDF...'
                                                                : (wasSent
                                                                    ? 'Reenviar'
                                                                    : (isBotActive ? 'Enviar PDF Automático' : 'Enviar con Link PDF')))}
                                                    </Button>
                                                </Stack>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </DialogContent>

                <DialogActions sx={{ px: 3, py: 2, justifyContent: 'space-between', flexWrap: 'wrap', gap: 1 }}>
                    <Typography variant="caption" color="text.secondary">
                        {(() => {
                            const total = processedReports?.reportsByCuadrilla?.length || 0;
                            const withPhone = (processedReports?.reportsByCuadrilla || []).filter(({ cuadrilla }) => {
                                const raw = whatsappPhones[cuadrilla.id] !== undefined
                                    ? whatsappPhones[cuadrilla.id]
                                    : (cuadrilla.nroTelefono || cuadrilla.telefono || '');
                                return formatPhoneForWhatsapp(raw).length >= 8;
                            }).length;
                            const sentCount = Object.keys(whatsappSentMap).filter(id => whatsappSentMap[id]).length;
                            return `${withPhone} de ${total} cuadrilla(s) con teléfono válido · ${sentCount} enviada(s)`;
                        })()}
                    </Typography>

                    <Stack direction="row" spacing={1.5}>
                        <Button onClick={() => setOpenWhatsappModal(false)} color="inherit">
                            Cerrar
                        </Button>
                        <Button
                            variant="contained"
                            color="success"
                            startIcon={<SendIcon />}
                            onClick={handleSendAllWhatsapp}
                            sx={{ backgroundColor: '#128C7E', '&:hover': { backgroundColor: '#075E54' } }}
                        >
                            Enviar Todos Juntos
                        </Button>
                    </Stack>
                </DialogActions>
            </Dialog>

            <Snackbar
                open={snackbarInfo.open}
                autoHideDuration={4000}
                onClose={handleCloseSanckbar}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <SnackAlert onClose={handleCloseSanckbar} severity={snackbarInfo.type} sx={{ width: '100%' }}>
                    {snackbarInfo.text}
                </SnackAlert>
            </Snackbar>
        </Container>
    );
};

export default ReporteComisiones;
